<!-- 出口报关组件 -->
 <template>
    <div>
        <!-- 报关单功能键 -->
        <div class="top_flex">
            <div>
                <!-- <el-button type="primary" icon="el-icon-edit-outline" size="mini" @click="saveDecInfo(true)" >暂存</el-button> -->
                 <el-button type="primary" icon="el-icon-edit-outline" size="mini" @click="saveDecInfo(true)"
                 :disabled=" decHead.id ? (decHead.inputerName === localStorageName ? false:true ) :false ">暂存</el-button>
                <el-button type="primary" icon="el-icon-plus" size="mini" @click="copyDeclare(false)">新建</el-button>
                <el-button type="primary" icon="el-icon-copy-document" size="mini" @click="copyDeclare(true)">复制</el-button>
                <el-button type="primary" icon="el-icon-delete" size="mini" @click="delDeclare" :disabled="(decHead.id !== '' && !decHead.checker)?false:true">删除</el-button>
                <el-button type="primary" icon="el-icon-document-checked" size="mini"  @click="saveDecInfo(false)" 
                 :disabled=" decHead.id ? (decHead.inputerName === localStorageName ? false:true ) :false ">提交复审</el-button>
                <el-button type="primary" icon="el-icon-document-remove" size="mini" :disabled="(decHead.entryType === 'M' && decHead.id)?false:true"
                 @click="uploadShow=true" >随附单据</el-button>
                <el-button type="primary" icon="el-icon-refresh-left" size="mini" @click="reject" 
                :disabled="(decHead.status === null?false:true) || (decHead.inputerName === localStorageName ? true:false)">驳回</el-button>
                <el-button type="primary" icon="el-icon-printer" size="mini" @click="report">打印</el-button>
                <span style="margin-left: 20px;"></span>
                <el-button type="primary" icon="el-icon-upload" size="mini"  @click="declareDecXml" :disabled="(decHead.id?false:true) || (decHead.status !== '驳回'?false:true)">申报</el-button>
                <!-- <el-button type="primary" icon="el-icon-upload" size="mini"  @click="declareDecXml" v-if="decHead.id && decHead.status !== '驳回'">申报</el-button> -->
                <!-- <el-button type="primary" icon="el-icon-s-order" size="mini">附注</el-button> -->
                <!-- <el-button type="primary" icon="el-icon-delete" size="mini">删除</el-button> -->
                <!-- <el-button type="primary" icon="el-icon-download" size="mini">引用电子底账</el-button> -->
                <!-- <el-button type="primary" icon="el-icon-phone-outline" size="mini">状态订阅</el-button> -->
                <span class="nameInput">初审人: {{ decHead.inputerName?decHead.inputerName:localStorageName }}</span>
                <span class="nameInput">复审人: {{ decHead.checker?decHead.checker:'' }}</span>
                <span class="nameInput" style="color: rgb(245, 108, 108);" v-if="decHead.status === '驳回'">驳回人: {{ decHead.rejectPerson?decHead.rejectPerson:'' }}</span>
                <span class="nameInput" style="color: rgb(245, 108, 108);" v-if="decHead.status === '驳回'">驳回原因: {{ decHead.rejectReason?decHead.rejectReason:'' }}</span>
            </div>
        </div>
        <div class="form_flex">
            <div style="width: 79%;">
                <el-form class="form_declare" :model="decHead" ref="decHead"  label-width="120px" size="mini" :rules="decHeadRules">
                    <el-row :gutter="24">
                        <el-col :span="12">
                            <el-form-item label="申报地海关" prop="customMaster">
                                <el-select :disabled="inputCode"  ref="customMasterText" class="width_100 yellow" filterable remote :remote-method="getCustomsList" :default-first-option="true" 
                                @focus="getCustomsList(decHead.customMaster)" v-model="decHead.customMaster" placeholder="请选择申报地海关"
                                 @change="emptyList($event,'customMaster')">
                                    <el-option v-for="item in customsList"  :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName " :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span >{{ item.codeName }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="申报状态" >
                                <el-input :disabled="inputCode || true"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="12">
                            <el-form-item label="统一编号" >
                                <el-input :disabled="inputCode || true" v-model="decHead.seqNo"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="预录入编号" >
                                <el-input :disabled="inputCode || true"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="12">
                            <el-form-item label="海关编号" >
                                <el-input :disabled="inputCode || true" v-model="decHead.entryNo"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item :label="exportCode==='EML' || exportCode==='E'?'出境关别':'进境关别'" prop="iePort"  >
                                <el-select :disabled="inputCode" ref="iePortText" class="width_100 yellow" remote :remote-method="getCustomsList" filterable :default-first-option="true"
                                :placeholder="(exportCode==='EML' || exportCode==='E')?'请选择出境关别':'请选择进境关别'" v-model="decHead.iePort" 
                                @change="emptyList($event,'iePort')" @focus="getCustomsList(decHead.iePort)">
                                    <el-option v-for="item in customsList" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName " 
                                    :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span >{{ item.codeName }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="12">
                            <el-form-item label="备案号" >
                                <el-input :disabled="inputCode" v-model="decHead.manualNo" clearable placeholder="请输入备案号"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="合同协议号" >
                                <el-input :disabled="inputCode" v-model="decHead.contrNo" clearable placeholder="请输入合同协议号"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="12">
                            <el-form-item :label="exportCode==='E'?'出口日期':(exportCode==='EML' ? '出境日期':(exportCode==='I' ? '进口日期':'进境日期'))" 
                            :prop="exportCode === 'I'?'ieDate':''" :class="exportCode==='I'?'yellow' : ''">
                                <el-input v-model="decHead.ieDate" class="width_100" placeholder="请输入日期" onkeyup="value=value.match(/\d{0,8}/,'')"
                                :disabled="(exportCode==='E' || exportCode==='EML' || inputCode)?true:false" > </el-input>
                                <!-- <el-date-picker v-model="decHead.ieDate" class="width_100" value-format="yyyy-MM-dd"  type="date" placeholder="选择日期"> </el-date-picker> -->
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="申报日期" >
                                <el-input :disabled="inputCode || true" ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="8" style="padding-right: 0px;">
                            <el-form-item label="境内收发货人"  prop="tradeCoScc">
                                <el-input :disabled="inputCode" class="yellow" v-model="decHead.tradeCoScc" placeholder="18位社会信用代码"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4" style="padding: 0px;">
                            <el-input :disabled="inputCode" v-model="decHead.tradeCode" placeholder="10位海关备案编码" size="mini"></el-input>
                        </el-col>
                        <el-col :span="4" style="padding: 0px;">
                            <el-input :disabled="inputCode || true" v-model="decHead.tradeCiqCode" size="mini" placeholder="10位检验检疫编码"></el-input>
                        </el-col>
                        <el-col :span="8" style="padding-left: 0px;">
                            <el-form-item label-width="0" prop="tradeName">
                                <el-select :disabled="inputCode" class="width_100 yellow" filterable remote :remote-method="getEnterpriseList" :default-first-option="true"
                                @change="enterpriseChange($event,'Trade')" placeholder="请选择企业" v-model="decHead.tradeName" @blur="selectBlur($event,'tradeName')">
                                    <el-option v-for="item in enterpriseList" :key="item.id" :label="item.companyName" :value="item.companyName + '-'  + item.hsCode + '-' + item.creditCode">
                                        <span>{{ item.companyName }}</span>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="16" style="padding-right: 0px;">
                            <el-form-item label="境外收发货人" >
                                <el-input :disabled="inputCode" v-model="decHead.overseasConsigneeCode" clearable placeholder="境外收发货人代码"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" style="padding-left: 0px;">
                            <el-input :disabled="inputCode" v-model="decHead.overseasConsigneeEname" clearable placeholder="企业名称(外文)" size="mini"></el-input>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="8" style="padding-right: 0px;">
                            <el-form-item :label="(exportCode==='E' || exportCode==='EML')?'生产销售单位':'消费使用单位'" prop="ownerCodeScc" >
                                <el-input :disabled="inputCode" class="yellow" v-model="decHead.ownerCodeScc" placeholder="18位社会信用社代码"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4" style="padding: 0px;">
                            <el-input :disabled="inputCode" v-model="decHead.ownerCode" placeholder="10位海关备案编码" size="mini"></el-input>
                        </el-col>
                        <el-col :span="4" style="padding: 0px;">
                            <el-input :disabled="inputCode || true" size="mini" placeholder="10位检验检疫编码"></el-input>
                        </el-col>
                        <el-col :span="8" style="padding-left: 0px;">
                            <el-form-item label-width="0" prop="ownerName">
                                <el-select :disabled="inputCode" class="width_100 yellow" filterable remote :remote-method="getEnterpriseList" :default-first-option="true"
                                placeholder="请选择企业" @change="enterpriseChange($event,'Owner')" v-model="decHead.ownerName" @focus="enterpriseList=[]"
                                @blur="selectBlur($event,'ownerName')">
                                    <el-option v-for="item in enterpriseList" :key="item.id" :label="item.companyName" :value="item.companyName + '-'  + item.hsCode + '-' + item.creditCode">
                                        <span>{{ item.companyName }}</span>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="8" style="padding-right: 0px;">
                            <el-form-item label="申报单位" prop="agentCodeScc" >
                                <el-input :disabled="inputCode || true" v-model="decHead.agentCodeScc" placeholder="18位社会信用社代码"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4" style="padding: 0px;" prop="agentCode">
                            <el-input :disabled="inputCode || true" v-model="decHead.agentCode" placeholder="10位海关备案编码" size="mini"></el-input>
                        </el-col>
                        <el-col :span="4" style="padding: 0px;">
                            <el-input  :disabled="inputCode || true" size="mini" placeholder="10位检验检疫编码"></el-input>
                        </el-col>
                        <el-col :span="8" style="padding-left: 0px;" prop="agentName">
                            <el-select :disabled="inputCode || true" class="width_100" size="mini" filterable remote :remote-method="getEnterpriseList" placeholder="请选择企业"
                            @change="enterpriseChange($event,'Agent')"  v-model="decHead.agentName" :default-first-option="true">
                                <el-option v-for="item in enterpriseList" :key="item.id" :label="item.companyName" :value="item.companyName + '-'  + item.hsCode + '-' + item.creditCode">
                                    <span>{{ item.companyName }}</span>
                                </el-option>
                            </el-select>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="6" >
                            <el-form-item label="运输方式" prop="trafMode" >
                                <el-select :disabled="inputCode" ref="trafModeText" class="width_100 yellow" filterable  placeholder="请选择运输方式" v-model="decHead.trafMode" :default-first-option="true">
                                    <el-option v-for="item in transportModeList" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName" :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span >{{ item.codeName }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6" style="padding: 0px;">
                            <el-form-item label="运输工具名称" >
                                <el-input :disabled="inputCode" v-model="decHead.trafName" clearable placeholder="请输入运输工具名称" size="mini"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" >
                            <el-form-item label="航次号" >
                                <el-input :disabled="inputCode" v-model="decHead.voyNo" clearable placeholder="请输入航次号" size="mini"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="12" >
                            <el-form-item label="提运单号" >
                                <el-input :disabled="inputCode" v-model="decHead.billNo" clearable placeholder="请输入提运单号" size="mini"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6" >
                            <el-form-item label="监管方式" prop="tradeMode" >
                                <el-select :disabled="inputCode" ref="tradeModeText" class="width_100 yellow" filterable :default-first-option="true" placeholder="请选择监管方式" v-model="decHead.tradeMode">
                                    <el-option v-for="item in superviseList" :key="item.cusCode" :label="item.cusCode + ' - ' + item.codeName" :value="item.cusCode">
                                        <span class="margin_right_20">{{ item.cusCode }}</span>
                                        <span >{{ item.codeName }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6" >
                            <el-form-item label="征免性质">
                                <el-select :disabled="inputCode" ref="cutModeText" clearable class="width_100" filterable :default-first-option="true" placeholder="请选择征免性质" v-model="decHead.cutMode">
                                    <el-option v-for="item in exemptionNatureList" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName" :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span >{{ item.codeName }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="6" >
                            <el-form-item label="许可证号" >
                                <el-input :disabled="inputCode" v-model="decHead.licenseNo" clearable placeholder="请输入许可证号" size="mini"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6" >
                            <el-form-item :label="(exportCode==='E' || exportCode==='EML')?'运抵国(地区)':'启运国(地区)	'" prop="tradeCountry">
                                <el-select :disabled="inputCode" ref="tradeCountryText" class="width_100 yellow" filterable :default-first-option="true" remote  :remote-method="getCountryList" 
                                :placeholder="(exportCode==='E' || exportCode==='EML')?'请选择运抵国(地区)':'请选择启运国(地区)'" 
                                v-model="decHead.tradeCountry" @change="tradeCountryChange" @focus="getCountryList(decHead.tradeCountry)">
                                    <el-option v-for="item in countryList" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName + ' - ' + item.cusCode" :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span class="margin_right_20">{{ item.codeName }}</span> 
                                        <span >{{ item.cusCode }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6" >
                            <el-form-item :label="(exportCode==='E' || exportCode==='EML')?'指运港':'经停港	'" prop="distinatePort">
                                <el-select :disabled="inputCode" ref="distinatePortText" class="width_100 yellow" filterable :default-first-option="true" remote :remote-method="getHarborList" @change="emptyList($event,'distinatePort')"
                                :placeholder="(exportCode==='E' || exportCode==='EML')?'请选择指运港':'请选择经停港'" v-model="decHead.distinatePort" @focus="getHarborList(decHead.distinatePort)">
                                    <el-option v-for="item in harborList" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName + ' - ' + item.cusCode" :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span class="margin_right_20">{{ item.codeName }}</span> 
                                        <span >{{ item.cusCode }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6" >
                            <el-form-item label="成交方式" prop="transMode">
                                <el-select :disabled="inputCode" ref="transModeText" class="width_100 yellow" filterable :default-first-option="true" placeholder="请选择成交方式" v-model="decHead.transMode">
                                    <el-option v-for="item in CUSTransacList" :key="item.codeValue"  :label="item.codeValue + ' - ' + item.codeName " :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span >{{ item.codeName }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="12" >
                            <el-form-item label="运费" >
                                <el-select style="width: 25%;" clearable filterable :default-first-option="true" 
                                v-model="decHead.feeMark"  placeholder="" :disabled ="feeMarkDis || inputCode">
                                    <el-option v-for="item in feeMarkList" :key="item.codeValue"  :label="item.codeName " :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span >{{ item.codeName }}</span> 
                                    </el-option>
                                </el-select>
                                <el-input clearable v-model="decHead.feeRate" :disabled="(decHead.feeMark ==='' || inputCode)?true:false" placeholder=" " size="mini" 
                                style="width: 50%;" onkeyup="value=value.match(/\d+\.?\d{0,2}/,'')"></el-input>
                                <el-select clearable filterable :default-first-option="true" placeholder="" style="width: 25%;" v-model="decHead.feeCurr" 
                                :disabled ="(!(decHead.feeMark !== '1'&& decHead.feeMark) || inputCode)?true:false">
                                    <el-option v-for="item in currencyList" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName + ' - ' + item.cusCode" :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span class="margin_right_20">{{ item.codeName }}</span> 
                                        <span >{{ item.cusCode }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" >
                            <el-form-item label="保险费" >
                                <el-select clearable style="width: 25%;" filterable :default-first-option="true" v-model="decHead.insurMark"  placeholder="" 
                                :disabled="insurMarkDis || inputCode">
                                    <el-option v-for="item in otherCostMarkList" :key="item.codeValue"  :label="item.codeName " :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span >{{ item.codeName }}</span> 
                                    </el-option>
                                </el-select>
                                <el-input clearable v-model="decHead.insurRate" :disabled="(decHead.insurMark ==='' || inputCode)?true:false" placeholder=" " size="mini" style="width: 50%;"
                                 onkeyup="value=value.match(/\d+\.?\d{0,2}/,'')"></el-input>
                                <el-select clearable filterable :default-first-option="true" placeholder="" style="width: 25%;" v-model="decHead.insurCurr" 
                                :disabled ="(!(decHead.insurMark !== '1'&& decHead.insurMark) || inputCode)?true:false">
                                    <el-option v-for="item in currencyList" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName + ' - ' + item.cusCode" :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span class="margin_right_20">{{ item.codeName }}</span> 
                                        <span >{{ item.cusCode }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="12" >
                            <el-form-item label="杂费" >
                                <el-select clearable style="width: 25%;" filterable :default-first-option="true" v-model="decHead.otherMark"  placeholder="" 
                                :disabled ="otherMarkDis || inputCode">
                                    <el-option v-for="item in otherCostMarkList" :key="item.codeValue"  :label="item.codeName " :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span >{{ item.codeName }}</span> 
                                    </el-option>
                                </el-select>
                                <el-input clearable v-model="decHead.otherRate" :disabled="(decHead.otherMark ==='' || inputCode)?true:false" placeholder=" " size="mini" style="width: 50%;"
                                onkeyup="value=value.match(/\d+\.?\d{0,2}/,'')" ></el-input>
                                <el-select clearable filterable :default-first-option="true" placeholder="" style="width: 25%;" v-model="decHead.otherCurr" 
                                :disabled ="(!(decHead.otherMark !== '1'&& decHead.otherMark) || inputCode)?true:false">
                                    <el-option v-for="item in currencyList" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName + ' - ' + item.cusCode" :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span class="margin_right_20">{{ item.codeName }}</span> 
                                        <span >{{ item.cusCode }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" >
                            <el-form-item label="件数"  prop="packNo">
                                <el-input :disabled="inputCode" class="yellow" onkeyup="value=value.replace(/[^\d]/g, '')" v-model="decHead.packNo" placeholder=" " size="mini" ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="12" >
                            <el-form-item label="包装种类" prop="wrapType">
                                <el-select :disabled="inputCode" ref="wrapTypeText" class="input_width yellow" filterable  placeholder="请选择包装种类" v-model="decHead.wrapType" :default-first-option="true">
                                    <el-option v-for="item in packageList" :key="item.packType" :label="item.packType + ' - ' + item.packTypeName" :value="item.packType">
                                        <span class="margin_right_20">{{ item.packType }}</span>
                                        <span >{{ item.packTypeName }}</span> 
                                    </el-option>
                                </el-select>
                                <el-button :disabled="inputCode" size="mini" type="primary" class="width_150" @click="packageOpen(0)">其他包装</el-button>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6" >
                            <el-form-item label="毛重(KG)" prop="grossWet">
                                <el-input :disabled="inputCode" class="yellow" v-model="decHead.grossWet" onkeyup="value=value.match(/\d+\.?\d{0,8}/,'')" placeholder=" "></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6" >
                            <el-form-item label="净重(KG)" prop="netWt">
                                <el-input :disabled="inputCode" class="yellow" v-model="decHead.netWt" onkeyup="value=value.match(/\d+\.?\d{0,8}/,'')" placeholder=" " size="mini"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="6" >
                            <el-form-item label="贸易国别(地区)" prop="tradeAreaCode">
                                <el-select :disabled="inputCode" ref="tradeAreaCodeText" class="width_100 yellow" filterable remote :remote-method="getCountryList" placeholder="请选择贸易国别(地区)" 
                                v-model="decHead.tradeAreaCode" @change="emptyList($event,'tradeAreaCode')" :default-first-option="true" @focus="getCountryList(decHead.tradeAreaCode)">
                                    <el-option v-for="item in countryList" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName + ' - ' + item.cusCode" :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span class="margin_right_20">{{ item.codeName }}</span> 
                                        <span >{{ item.cusCode }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6" >
                            <el-form-item label="集装箱数" >
                                <el-input :disabled="inputCode || true" placeholder=" " size="mini"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" >
                            <el-form-item label="随附单证" >
                                <el-input :disabled="inputCode || true" placeholder=" " size="mini" ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="(exportCode==='EML' || exportCode==='IML')?6:12">
                            <el-form-item  :label="(exportCode==='EML' || exportCode==='E')?'离境口岸':'入境口岸'" prop="entyPortCode">
                                <el-select :disabled="inputCode" ref="entyPortCodeText" class="width_100 yellow" filterable remote :remote-method="getSeaportList"  :default-first-option="true"
                                :placeholder="(exportCode==='EML' || exportCode==='E')?'请选择离境口岸':'请选择入境口岸'" v-model="decHead.entyPortCode" 
                                @change="emptyList($event,'entyPortCode')" @focus="getSeaportList(decHead.entyPortCode)" >
                                    <el-option v-for="item in seaportList" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName" :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span >{{ item.codeName }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="(exportCode==='IML' || exportCode==='I')?6:12">
                            <el-form-item label="货物存放地点" >
                                <el-input :disabled="inputCode" clearable :class="(exportCode==='IML' || exportCode==='I')?'yellow' : ''" v-model="decHead.goodsPlace" placeholder="请输入货物存放地点"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6" v-if="exportCode==='IML' || exportCode==='I'">
                            <el-form-item label="启运港" prop="despPortCode">
                                <el-select :disabled="inputCode" ref="despPortCodeText" class="width_100 yellow" filterable :default-first-option="true" remote :remote-method="getHarborList" @change="emptyList($event,'despPortCode')"
                                placeholder="请选择启运港" v-model="decHead.despPortCode" >
                                    <el-option v-for="item in harborList" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName + ' - ' + item.cusCode" :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span class="margin_right_20">{{ item.codeName }}</span>
                                        <span >{{ item.cusCode }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col v-if="exportCode==='EML' || exportCode==='IML'" :span="6">
                            <el-form-item  label="清单类型" >
                                <el-select :disabled="inputCode" class="width_100 yellow" filterable :default-first-option="true" placeholder="请选择清单类型"  
                                v-model="decHead.billType" >
                                    <el-option v-for="item in listType" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName" :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span >{{ item.codeName }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="6">
                            <el-form-item label="报关单类型" prop="entryType">
                                <el-select :disabled="inputCode" class="width_100 yellow" filterable  placeholder="请选择报关单类型" v-model="decHead.entryType" :default-first-option="true">
                                    <el-option v-for="item in CUSDeclarationList" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName" :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span >{{ item.codeName }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="18">
                            <el-form-item label="备注" >
                                <span style="display: flex;justify-content: space-between;">
                                    <div class="top_flex input_width" style="margin: 0px;">
                                        <el-input :disabled="inputCode" clearable v-model="decHead.noteS" placeholder="请输入备注" ></el-input>
                                        <span class="enterprise_buttons"">
                                            <el-button :disabled="inputCode" @click="textareaOpen('备注',decHead.noteS)" icon="el-icon-more" circle size="mini" ></el-button>
                                        </span>
                                    </div>
                                    <el-button :disabled="inputCode" size="mini" type="primary" class="width_150" style="margin-bottom: 1px;" @click="priceShow = true">价格说明</el-button>
                                </span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="6">
                            <el-button @click="formTopCode" v-if="form_top_code" icon="el-icon-arrow-down" circle size="mini" style="margin-left: 10px;"></el-button>
                            <el-button @click="formTopCode" v-else icon="el-icon-arrow-right" circle size="mini" style="margin-left: 10px;"></el-button>
                        </el-col>
                        <el-col :span="18">
                            <el-form-item label="标记唛码" >
                                <span style="display: flex;justify-content: space-between;">
                                    <div class="top_flex input_width" style="margin: 0px;">
                                        <el-input :disabled="inputCode" clearable v-model="decHead.markNo" placeholder="请输入标记唛码" ></el-input>
                                        <span class="enterprise_buttons"">
                                            <el-button :disabled="inputCode" @click="textareaOpen('标记唛码',decHead.markNo)" icon="el-icon-more" circle size="mini"></el-button>
                                        </span>
                                    </div>
                                    <el-button :disabled="inputCode" size="mini" type="primary" class="width_150" @click="specialBusinessOpen(1)">业务事项</el-button>
                                </span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <div v-show="form_top_code">
                        <el-row :gutter="24">
                            <el-col :span="(exportCode==='IML' || exportCode==='I')?6:12">
                                <el-form-item label="目的地海关" >
                                    <el-select :disabled="inputCode" class="width_100" filterable remote :remote-method="getCustomsList" :default-first-option="true" placeholder="请选择目的地海关" 
                                    v-model="decHead.purpOrgCode" @change="emptyList($event,'purpOrgCode')">
                                        <el-option v-for="item in customsList" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName " :value="item.codeValue">
                                            <span class="margin_right_20">{{ item.codeValue }}</span>
                                            <span >{{ item.codeName }}</span> 
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6" v-if="exportCode==='IML' || exportCode==='I'">
                                <el-form-item label="启运日期" prop="despDate">
                                    <el-date-picker :disabled="inputCode" v-model="decHead.despDate" class="width_100 yellow" value-format="yyyy-MM-dd"  type="date" placeholder="选择日期"> </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" >
                                <el-form-item label="企业资质" >
                                    <div class="top_flex" style="margin: 0px;">
                                        <el-input :disabled="inputCode || true" placeholder="" style="width: 20%;"></el-input>
                                        <el-input :disabled="inputCode || true" placeholder="" style="width: 65%;"></el-input>
                                        <span class="enterprise_buttons" style=" width: 15%;">
                                            <el-button :disabled="inputCode" icon="el-icon-arrow-left" circle size="mini" ></el-button>
                                            <el-button :disabled="inputCode" icon="el-icon-arrow-right" circle size="mini" ></el-button>
                                            <el-button :disabled="inputCode" @click="enterpriseOpen(0)" icon="el-icon-more" circle size="mini"></el-button>
                                        </span>
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="24">
                            <el-col :span="6" v-if="exportCode==='IML' || exportCode==='I'">
                                <el-form-item label="B/L号" >
                                    <el-input :disabled="inputCode" v-model="decHead.blNo" placeholder="请输入B/L号" ></el-input>
                                </el-form-item>                        
                            </el-col>
                            <el-col :span="(exportCode==='IML' || exportCode==='I')?6:12">
                                <el-form-item label="特殊业务标识" >
                                    <div class="top_flex" style="margin: 0px;">
                                        <el-input v-model="decHead.specDeclFlagText" :disabled="inputCode || true"></el-input>
                                        <span class="enterprise_buttons">
                                            <el-button :disabled="inputCode" @click="specialBusinessOpen(0)" icon="el-icon-more" circle size="mini" ></el-button>
                                        </span>
                                    </div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="关联号码及理由" >
                                    <span style="display: flex;width: 100%;">
                                        <div :class="exportCode==='IML' || exportCode==='I'? 'input_width':'width_100'">
                                            <el-input :disabled="inputCode" v-model="decHead.correlationNo" placeholder="请输入关联号码" style="width: 40%;"></el-input>
                                            <el-input :disabled="inputCode" v-model="decHead.correlationReasonFlag" placeholder="请输入关联理由" style="width: 60%;"></el-input>
                                        </div>
                                        <el-button :disabled="inputCode" v-if="exportCode==='IML' || exportCode==='I'" @click="enterpriseOpen(1)" size="mini" type="primary" class="width_150">使用人</el-button>
                                    </span>
                                </el-form-item>                        
                            </el-col>  
                        </el-row>
                        <el-row :gutter="24">
                            <el-col v-if="exportCode==='IML' || exportCode==='I'" :span="6" >
                                <el-form-item label="原箱运输" >
                                    <el-select :disabled="inputCode" class="width_100" filterable :default-first-option="true" placeholder="请选择原箱运输" 
                                        v-model="decHead.origBoxFlag">
                                            <el-option v-for="item in trueORfalse" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName " :value="item.codeValue">
                                                <span class="margin_right_20">{{ item.codeValue }}</span>
                                                <span >{{ item.codeName }}</span> 
                                            </el-option>
                                        </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="(exportCode==='IML' || exportCode==='I')?18:24" >
                                <el-form-item label="所需单证" >
                                    <el-input :disabled="inputCode || true" placeholder="" class="input_width"></el-input>
                                    <el-button :disabled="inputCode" @click="packageOpen(1)" size="mini" type="primary" class="width_150">检验检疫签证申报要素</el-button>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-form>
                <!-- 商品 -->
                <div class="good_flex">
                    <div >
                        <!-- <el-button type="primary" icon="el-icon-plus" size="mini">导入</el-button> -->
                        <el-button :disabled="inputCode" type="primary" icon="el-icon-plus" size="mini" @click="addGoodsList">新增</el-button>
                        <!-- <el-button type="primary" icon="el-icon-document-checked" size="mini">保存</el-button> -->
                        <el-button :disabled="inputCode" type="primary" icon="el-icon-delete" size="mini" @click="deleteGoodsDetails">删除</el-button>
                        <el-button :disabled="inputCode" type="primary" icon="el-icon-copy-document" size="mini" @click="copyGoods">复制</el-button>
                        <el-button :disabled="inputCode" type="primary" icon="el-icon-copy-document" size="mini" @click="moveGoodsList('top')">上移</el-button>
                        <el-button :disabled="inputCode" type="primary" icon="el-icon-copy-document" size="mini" @click="moveGoodsList('bottom')">下移</el-button>
                        <!-- <el-button type="primary" icon="el-icon-copy-document" size="mini">插入</el-button> -->
                        <el-button :disabled="inputCode" type="primary" icon="el-icon-copy-document" size="mini" @click="newClassify(false)">重新归类</el-button>
                        <el-button type="primary" icon="el-icon-copy-document" size="mini" @click="newClassify(true)">查看归类</el-button>
                        
                        <el-upload class="upload-demo" style="display:inline;margin-left: 10px;margin-right: 10px;"  :action="importDetailAction" 
                        :file-list="importDetailFile" :headers="headers" :show-file-list="false" :on-success="importDetailData" :on-error="errorData"  >
                            <el-button size="mini" type="primary" icon="el-icon-top" >导入明细</el-button>
                        </el-upload>

                        <!-- <el-button type="primary" icon="el-icon-copy-document" size="mini">批量修改</el-button> -->
                        <!-- <el-button type="primary" v-if="exportCode!=='EML' || exportCode!=='IML'" icon="el-icon-copy-document" size="mini">补充申报</el-button> -->
                        <!-- <el-button type="primary" icon="el-icon-copy-document" size="mini">归类先例</el-button> -->
                        <!-- <el-button type="primary" icon="el-icon-copy-document" size="mini">删除享惠</el-button> -->
                    </div>
                    <div>
                        <el-button type="success" icon="el-icon-bottom" size="mini" @click="DowloadExcel">
                            下载模板
                        </el-button>
                        <!-- <el-button type="primary" icon="el-icon-s-operation" size="mini"></el-button> -->
                        <el-button type="primary" icon="el-icon-refresh-right" size="mini"></el-button>
                    </div>
                </div>
                <!-- 表格 -->
                <!-- :header-cell-style="{'text-align':'center'}" -->
                <el-table style="width: 100%;" size="mini"  ref="decList" :data="decList" height="250px"
                highlight-current-row  @current-change="goodsDetailsShow" :header-cell-style="{'text-align':'center'}">
                    <el-table-column label="项号" prop="gNo" width="50" > </el-table-column>
                    <el-table-column label="备案序号" prop="contrItem" width="120" align="center"> </el-table-column>
                    <el-table-column label="商品编号" prop="codeTs"  width="120" align="center"> </el-table-column>
                    <el-table-column label="监督类别名称" prop="ciqCode" width="120" align="center"> </el-table-column>
                    <el-table-column label="商品名称" prop="gName" width="120" align="center"> </el-table-column>
                    <el-table-column label="规格" prop="gModel"  width="250" align="center"> 
                        <template slot-scope="scope">
                            <span class="omitText"> {{ scope.row.gModel }} </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="成交数量" prop="gQty" align="center"> </el-table-column>
                    <el-table-column label="成交单位" prop="gUnit" align="center"> </el-table-column>
                    <el-table-column label="单价" prop="declPrice" align="center"> </el-table-column>
                    <el-table-column label="总价" prop="declTotal" align="center"> </el-table-column>
                    <el-table-column label="币制" prop="tradeCurr" align="center"> </el-table-column>
                    <el-table-column :label="exportCode==='EML' || exportCode==='E'?'原产国（地区）':'最终目的国'" prop="destinationCountry" width="120" align="center"> </el-table-column>
                    <el-table-column :label="exportCode==='EML' || exportCode==='E'?'最终目的国':'原产国（地区）'" prop="originCountry" width="120" align="center"> </el-table-column>
                    <el-table-column label="征免方式" prop="dutyMode" align="center"> </el-table-column>
                    <!-- <el-table-column label="监管要求"> </el-table-column> -->
                </el-table>
                <!-- 表单 -->
                <el-form class="form_declare" :model="decListItem" ref="decListItem" label-width="130px" size="mini" :rules="decListItemRules" >
                    <el-row :gutter="24">
                        <el-col :span="5">
                            <el-form-item label="项号" >
                                <el-input v-model="decListItem.gNo" :disabled="inputCode || true" ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="备案序号" > 
                                <el-input :disabled="inputCode" clearable v-model="decListItem.contrItem" onkeyup="value=value.match(/\d{0,9}/,'')"  ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="商品编号" label-width="100px" prop="codeTs">
                                <el-input :disabled="inputCode" class="yellow" @keyup.enter.native="goodsCodeEnter" v-model.trim="decListItem.codeTs" placeholder="录入后按Enter键" ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="9">
                            <el-form-item label="监管类别名称" label-width="100px" >
                                <div class="top_flex" style="margin: 0px;">
                                    <div class="disabledInput" @dblclick="delregulatory">
                                        {{ decListItem.ciqName }}
                                    </div>
                                    <span class="enterprise_buttons">
                                        <el-button :disabled="inputCode" icon="el-icon-more" circle size="mini" @click="regulatoryOpen"></el-button>
                                    </span>
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="10">
                            <el-form-item label="商品名称" prop="gName">
                                <el-input :disabled="inputCode" class="yellow" v-model="decListItem.gName" placeholder="请输入商品名称"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="14">
                            <el-form-item label="规格型号" label-width="100px" >
                                <el-input :disabled="inputCode || true" v-model="decListItem.gModel" ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="5">
                            <el-form-item label="成交数量" prop="gQty">
                                <el-input :disabled="inputCode" class="yellow" onkeyup="value=value.match(/\d+\.?\d{0,4}/,'')" v-model="decListItem.gQty" 
                                placeholder="请输入成交数量" @blur="priceCount('gQty')"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="成交计量单位" prop="gUnit" > 
                                <el-select :disabled="inputCode" class="width_100 yellow" filterable remote :remote-method="getUnitList" :default-first-option="true" 
                                v-model="decListItem.gUnit" placeholder="请选择成交计量单位" @change="emptyList($event,'gUnit')" @focus="getUnitList(decListItem.gUnit)">
                                    <el-option v-for="item in unitList"  :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName " :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span >{{ item.codeName }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="单价" label-width="100px" prop="declPrice">
                                <el-input :disabled="inputCode" v-model="decListItem.declPrice" onkeyup="value=value.match(/\d+\.?\d{0,4}/,'')" @blur="inputPprice('declPrice')"
                                class="yellow" placeholder="请输入单价"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                            <el-form-item label="总价" label-width="100px" prop="declTotal">
                                <el-input :disabled="inputCode" v-model="decListItem.declTotal" onkeyup="value=value.match(/\d+\.?\d{0,2}/,'')" @blur="inputPprice('declTotal')"
                                class="yellow" placeholder="请输入总价"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="币制" prop="tradeCurr" >
                                <el-select :disabled="inputCode" class="width_100 yellow" filterable :default-first-option="true" placeholder="请选择币制" 
                                    v-model="decListItem.tradeCurr">
                                    <el-option v-for="item in currencyList" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName + ' - ' + item.cusCode" :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span class="margin_right_20">{{ item.codeName }}</span> 
                                        <span >{{ item.cusCode }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="5">
                            <el-form-item label="法定第一数量" prop="firstQty">
                                <el-input :disabled="decListItem.firstUnit === '' || inputCode" v-model="decListItem.firstQty" onkeyup="value=value.match(/\d+\.?\d{0,4}/,'')" 
                                :class="decListItem.firstUnit === ''?'':'yellow'" placeholder="请输入法定第一数量" @blur="priceCount('firstQty')"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="法定第一计量单位" >
                                <el-select class="width_100 " v-model="decListItem.firstUnit" :disabled="inputCode || true">
                                    <el-option v-for="item in unitList"  :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName " :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span >{{ item.codeName }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="加工成品单耗版本号" label-width="145px" >
                                <el-input :disabled="inputCode" clearable v-model="decListItem.exgVersion" placeholder="请输入版本号"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                            <el-form-item label="货号" label-width="100px" >
                                <el-input :disabled="inputCode" clearable v-model="decListItem.exgNo" placeholder="请输入货号"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="最终目的国(地区)" prop="originCountry">
                                <!-- 出口 -->
                                <el-select :disabled="inputCode" v-if="exportCode==='EML' || exportCode==='E'" class="width_100 yellow" filterable remote :remote-method="getCountryList" placeholder="请选择最终目的国(地区)" 
                                v-model="decListItem.originCountry" @change="emptyList($event,'originCountry')" :default-first-option="true" @focus="getCountryList(decListItem.originCountry)">
                                    <el-option v-for="item in countryList" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName + ' - ' + item.cusCode" :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span class="margin_right_20">{{ item.codeName }}</span> 
                                        <span >{{ item.cusCode }}</span> 
                                    </el-option>
                                </el-select>
                                <el-select :disabled="inputCode" v-else class="width_100 yellow" filterable remote :remote-method="getCountryList" placeholder="请选择最终目的国(地区)" 
                                v-model="decListItem.destinationCountry" @change="emptyList($event,'destinationCountry')" :default-first-option="true" @focus="getCountryList(decListItem.destinationCountry)">
                                    <el-option v-for="item in countryList" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName + ' - ' + item.cusCode" :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span class="margin_right_20">{{ item.codeName }}</span> 
                                        <span >{{ item.cusCode }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="5">
                            <el-form-item label="法定第二数量" >
                                <el-input :disabled="decListItem.secondUnit === '' || inputCode" v-model="decListItem.secondQty" onkeyup="value=value.match(/\d+\.?\d{0,4}/,'')"
                                 placeholder="请输入法定第二数量"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="法定第二计量单位" >
                                <el-select class="width_100 " v-model="decListItem.secondUnit" :disabled="inputCode || true" placeholder=" ">
                                    <el-option v-for="item in unitList"  :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName " :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span >{{ item.codeName }}</span> 
                                    </el-option>
                                </el-select>
                                <!-- <el-input v-model="decListItem.secondUnit" :disabled="inputCode || true"></el-input> -->
                            </el-form-item>
                        </el-col>
                        <el-col  :span="14">
                        <!-- <el-col  :span="(exportCode==='IML' || exportCode==='I')? 5:14"> -->
                            <el-form-item label="原产国（地区）" label-width="145px" prop="destinationCountry" >
                                <span style="display: flex;width: 100%;">
                                    <el-select :disabled="inputCode" v-if="exportCode==='EML' || exportCode==='E'" class="input_width yellow" filterable remote :remote-method="getCountryList" 
                                    placeholder="请选择原产国（地区）" v-model="decListItem.destinationCountry" @change="emptyList($event,'destinationCountry')" 
                                    :default-first-option="true" @focus="getCountryList(decListItem.destinationCountry)">
                                        <el-option v-for="item in countryList" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName + ' - ' + item.cusCode" :value="item.codeValue">
                                            <span class="margin_right_20">{{ item.codeValue }}</span>
                                            <span class="margin_right_20">{{ item.codeName }}</span> 
                                            <span >{{ item.cusCode }}</span>  
                                        </el-option>
                                    </el-select>
                                    <el-select :disabled="inputCode" v-else class="input_width yellow" filterable remote :remote-method="getCountryList" placeholder="请选择原产国（地区）" 
                                    v-model="decListItem.originCountry" @change="emptyList($event,'originCountry')" :default-first-option="true" @focus="getCountryList(decListItem.originCountry)">
                                        <el-option v-for="item in countryList" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName + ' - ' + item.cusCode" :value="item.codeValue">
                                            <span class="margin_right_20">{{ item.codeValue }}</span>
                                            <span class="margin_right_20">{{ item.codeName }}</span> 
                                            <span >{{ item.cusCode }}</span>  
                                        </el-option>
                                    </el-select>
                                    <el-button size="mini" :disabled="(exportCode==='EML'|| exportCode==='IML' || inputCode)?true:false" type="primary" class="width_150" @click="decDocLayerXiangHui">协定享惠</el-button>
                                </span>
                            </el-form-item>
                        </el-col>
                        <!-- <el-col v-if="(exportCode==='IML' || exportCode==='I')" :span="9">
                            <el-form-item label="原产地区" label-width="100px" >
                                <el-select class="input_width yellow" filterable remote :remote-method="getCountryList" placeholder="请选择原产地区" 
                                v-model="decListItem.origPlaceCode" @change="emptyList($event,'destinationCountry')" :default-first-option="true"
                                 @focus="getCountryList(decListItem.origPlaceCode)">
                                    <el-option v-for="item in countryList" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName + ' - ' + item.cusCode" :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span class="margin_right_20">{{ item.codeName }}</span> 
                                        <span >{{ item.cusCode }}</span>  
                                    </el-option>
                                </el-select>
                                <el-button size="mini" :disabled="(exportCode==='EML'|| exportCode==='IML')?true:false" type="primary" class="width_150">协定享惠</el-button>
                            </el-form-item>
                        </el-col> -->
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="5">
                            <el-button @click="formBottomCode" v-if="form_bottom_code" icon="el-icon-arrow-down" circle size="mini" style="margin-left: 10px;"></el-button>
                            <el-button @click="formBottomCode" v-else icon="el-icon-arrow-right" circle size="mini" style="margin-left: 10px;"></el-button>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item :label="(exportCode==='EML' || exportCode==='E')?'境内货源地':'境内目的地'" prop="districtCode">
                                <el-select :disabled="inputCode" class="width_100 yellow" filterable remote :remote-method="getDomesticDestinationList" :placeholder="(exportCode==='EML' || exportCode==='E')?'请选择境内货源地':'请选择境内目的地'" 
                                v-model="decListItem.districtCode" @change="emptyList($event,'districtCode')" :default-first-option="true"
                                @focus="getDomesticDestinationList(decListItem.districtCode)">
                                    <el-option v-for="item in domesticDestinationList" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName" :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span >{{ item.codeName }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label-width="0px">
                                <el-select :disabled="inputCode" clearable class="width_100" filterable remote :remote-method="getOrigPlaceCodeList" :placeholder="(exportCode==='EML' || exportCode==='E')?'请选择产地':'请选择目的地'"
                                v-model="decListItem.destCode" @change="emptyList($event,'destCode')" :default-first-option="true"
                                @focus="getOrigPlaceCodeList(decListItem.destCode)">
                                    <el-option v-for="item in origPlaceCodeList" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName" :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span >{{ item.codeName }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="征免方式" >
                                <el-select :disabled="inputCode" clearable class="width_100 yellow" filterable :default-first-option="true" placeholder="征免方式" 
                                    v-model="decListItem.dutyMode" @keyup.enter.native="addGoosdList">
                                    <el-option v-for="item in dutyModeList" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName " :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span >{{ item.codeName }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <div v-show="form_bottom_code">
                        <el-row :gutter="24">
                            <el-col :span="24">
                                <el-form-item label="检验检疫货物规格" >
                                    <div class="top_flex" style="margin: 0px;">
                                        <div class="disabledInput">
                                            {{ decListItem.stuff?decListItem.stuff + ';':'' }}
                                            {{ decListItem.prodValidDt?decListItem.prodValidDt + ';':'' }}
                                            {{ decListItem.prodQgp?decListItem.prodQgp + ';':'' }}
                                            {{ decListItem.engManEntCnm?decListItem.engManEntCnm + ';':'' }}
                                            {{ decListItem.goodsSpec?decListItem.goodsSpec + ';':'' }}
                                            {{ decListItem.goodsModel?decListItem.goodsModel + ';':'' }}
                                            {{ decListItem.goodsBrand?decListItem.goodsBrand + ';':'' }}
                                            {{ decListItem.prodBatchNo?decListItem.prodBatchNo + ';':'' }}
                                            {{ decListItem.mnufctrRegNo?decListItem.mnufctrRegNo + ';':'' }}
                                        </div>
                                        <span class="enterprise_buttons">
                                            <el-button :disabled="inputCode" icon="el-icon-more" circle size="mini" style="margin-left: 10px;" @click="goodsInspectionShow = true"></el-button>
                                        </span>
                                        <el-button :disabled="inputCode" v-if="exportCode==='IML' || exportCode==='I'" size="mini" type="primary" class="width_150">商品单据</el-button>
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="24">
                            <el-form-item label="生产日期" >
                                <el-date-picker :disabled="inputCode" v-model="decListItem.produceDate" class="input_width" value-format="yyyy-MM-dd"  type="date" placeholder="选择日期"> </el-date-picker>
                                <el-button :disabled="inputCode" size="mini" type="primary" class="width_150">产品资质</el-button>
                            </el-form-item>
                        </el-row>
                        <el-row :gutter="24">
                            <el-col :span="10">
                                <el-form-item label="货物属性" >
                                    <div class="top_flex" style="margin: 0px;">
                                        <el-input v-model="decListItem.goodsAttrText" :disabled="inputCode || true" style="width: 90%;" ></el-input>
                                        <span class="enterprise_buttons">
                                            <el-button icon="el-icon-more" circle size="mini" style="margin-left: 10px;" @click="cargoOpen"></el-button>
                                        </span>
                                    </div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="14">
                                <el-form-item label="用途" > 
                                    <el-select :disabled="inputCode" class="input_width" filterable :default-first-option="true" placeholder="请选择用途" 
                                    v-model="decListItem.purpose">
                                        <el-option v-for="item in purposeList" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName " :value="item.codeValue">
                                            <span class="margin_right_20">{{ item.codeValue }}</span>
                                            <span >{{ item.codeName }}</span> 
                                        </el-option>
                                    </el-select>
                                <el-button :disabled="inputCode" size="mini" type="primary" class="width_150" @click="goodsDangerousShow = true">危险货物信息</el-button>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-form>
            </div>
            <!-- 集装箱 -->
            <div class="container">
                <div >
                    <el-button type="primary" icon="el-icon-plus" size="mini">导入</el-button>
                    <el-button type="primary" icon="el-icon-plus" size="mini" @click="addDecContainerItem">新增</el-button>
                    <el-button type="primary" icon="el-icon-delete" size="mini" @click="delDecContainerItem">删除</el-button>
                </div>
                <el-table size="mini" height="150" ref="decContainer" :data="decContainer" highlight-current-row
                 @current-change="decContainerShow" >
                    <el-table-column label="序号" prop="containerNum"  width="50px"> </el-table-column>
                    <el-table-column label="集装箱号" prop="containerId"> </el-table-column>
                    <el-table-column label="集装箱规格" prop="containerMd"> </el-table-column>
                    <el-table-column label="拼箱标识" prop="lclFlag"> </el-table-column>
                </el-table>
                <el-form label-width="110px" size="mini" :model="decContainerItem" ref="decContainerItem" :rules="decContainerRules">
                    <el-form-item label="集装箱号" prop="containerId">
                        <el-input class="yellow" placeholder="请输入集装箱号" v-model.trim="decContainerItem.containerId"></el-input>
                        <!-- 限制输入十一位 -->
                    </el-form-item>
                    <el-form-item label="集装箱规格" prop="containerMd">
                        <el-select class="width_100 yellow" filterable :default-first-option="true" placeholder="请选择集装箱规格" 
                        v-model="decContainerItem.containerMd">
                            <el-option v-for="item in containersMDList" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName " :value="item.codeValue">
                                <span class="margin_right_20">{{ item.codeValue }}</span>
                                <span >{{ item.codeName }}</span> 
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="自重(KG)" >
                        <el-input clearable v-model="decContainerItem.containerWt" onkeyup="value=value.match(/\d+\.?\d{0,4}/,'')" placeholder="请输入自重"></el-input>
                    </el-form-item>
                    <el-form-item label="拼箱标识" >
                        <el-select clearable class="width_100" filterable :default-first-option="true" placeholder="请选择拼箱标识" 
                        v-model="decContainerItem.lclFlag">
                            <el-option v-for="item in trueORfalse" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName " :value="item.codeValue">
                                <span class="margin_right_20">{{ item.codeValue }}</span>
                                <span >{{ item.codeName }}</span> 
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="商品项号关系" prop="goodsNo" > 
                        <!-- 逗号隔开 -->
                        <div class="top_flex width_100" style="margin: 0px;">
                            <!-- @keyup.enter.native="addDecContainer" -->
                            <el-input v-model="decContainerItem.goodsNo" :disabled="true" placeholder="请选择商品项号" ></el-input>
                            <span class="enterprise_buttons">
                                <el-button @click="goodsNoChange" icon="el-icon-more" circle size="mini" ></el-button>
                            </span>
                        </div>
                    </el-form-item>
                </el-form>
                <div class="enterprise_buttons" style="margin-top: 5px;">
                    <el-button type="primary" size="mini" @click="addDecContainer">添加/修改</el-button>
                </div>
                <div>
                    <el-button type="primary" icon="el-icon-plus" size="mini" @click="addLicenseList">新增</el-button>
                    <el-button type="primary" icon="el-icon-delete" size="mini" @click="delLicenseList">删除</el-button>
                    <el-button type="primary" size="mini">对应关系</el-button>
                </div>
                <!-- 随附单证编号回车添加 -->
                <el-table size="mini" height="150" ref="decLicenseDocus" :data="decLicenseDocus" highlight-current-row
                 @current-change="decLicenseDocusShow">
                    <el-table-column label="序号" prop="licenseNum" width="50px"> </el-table-column>
                    <!-- <el-table-column  type="selection"  width="55"> </el-table-column> -->
                    <el-table-column label="单证" prop="docuCode"> </el-table-column>
                    <el-table-column label="单证编码" prop="certCode"> </el-table-column>
                </el-table>
                <el-form label-width="110px" size="mini" :model="decLicenseDocusItem" ref="decLicenseDocusItem" :rules="decLicenseDocusRules">
                    <el-form-item label="随时单证代码" prop="docuCode">
                        <el-select class="width_100 yellow" filterable :default-first-option="true" placeholder="请选择单证代码" 
                        v-model="decLicenseDocusItem.docuCode">
                            <el-option v-for="item in documentationList" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName " :value="item.codeValue">
                                <span class="margin_right_20">{{ item.codeValue }}</span>
                                <span >{{ item.codeName }}</span> 
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="随时单证编号" >
                        <el-input v-model="decLicenseDocusItem.certCode" class="width_100 yellow" placeholder="请输入编号"
                         @keyup.enter.native="enterLicenseList" ></el-input>
                    </el-form-item>
                    <el-form-item label="关联报关单" >
                        <el-input clearable v-model="decHead.relId" placeholder="请输入报关单号"></el-input>
                    </el-form-item>
                    <el-form-item label="关联备案" >
                        <el-input clearable v-model="decHead.relManNo" placeholder="请输入备案号"></el-input>
                    </el-form-item>
                    <el-form-item label="保税/监管场地" >
                        <el-input clearable placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="场地代码" >
                        <el-input clearable placeholder="请输入"></el-input>
                    </el-form-item>
                </el-form>
                <!-- tips -->
                <div class="tips_box">
                    <div class="flex_start">
                        <div class="tips_item_width">tips： </div>
                        <span>总价 {{  tipsTotal.allTotal }}</span>
                    </div>
                    <div class="tips_item">
                        成交数量合计 {{  tipsTotal.allGqty }}
                        &nbsp;
                        <el-popover placement="top" title="按成交计量单位汇总如下:" width="250" trigger="hover" >
                            <div v-for="item in tipsTotal.gQtyMap">
                                {{ item.type }} &nbsp; {{ item.total }}
                            </div>
                            <el-button slot="reference" size="mini">∑ 汇总</el-button>
                        </el-popover>
                    </div>
                    <div class="tips_item">
                        法定第一数量合计  {{  tipsTotal.allFirstQty }}
                        &nbsp;
                        <el-popover placement="top" title="按法定第一计量单位汇总如下:" width="250" trigger="hover" >
                            <div v-for="item in tipsTotal.firstQtyMap">
                                {{ item.type }} &nbsp; {{ item.total }}
                            </div>
                            <el-button slot="reference" size="mini">∑ 汇总</el-button>
                        </el-popover>
                    </div>
                    <div class="tips_item">
                        法定第二数量合计  {{  tipsTotal.allSecondQty }}
                        &nbsp;
                        <el-popover placement="top" title="按法定第二计量单位汇总如下:" width="250" trigger="hover" >
                            <div v-for="item in tipsTotal.secondQtyMap">
                                {{ item.type }} &nbsp; {{ item.total }}
                            </div>
                            <el-button slot="reference" size="mini">∑ 汇总</el-button>
                        </el-popover>
                    </div>
                    <div class="tips_item">
                        重量合计(千克) {{ tipsTotal.allWeightKG }}
                        &nbsp;
                        <el-popover placement="top" title="按商品计量单位为&quot;千克&quot;汇总如下:" width="250" trigger="hover" >
                            <div>
                                千克 &nbsp; {{ tipsTotal.allWeightKG }}
                            </div>
                            <el-button slot="reference" size="mini">∑ 汇总</el-button>
                        </el-popover>
                    </div>
                    <div class="tips_item">
                        币制合计
                        &nbsp;
                        <el-popover placement="top" title="按商品币制汇总如下:" width="250" trigger="hover" >
                            <div v-for="item in tipsTotal.tradeCurrMap">
                                {{ item.type }} &nbsp; {{ item.total }}
                            </div>
                            <el-button slot="reference" size="mini">∑ 汇总</el-button>
                        </el-popover>
                    </div>
                </div>
            </div>
        </div>
        <!-- 商品编辑检验检疫货物规格 -->
         <el-dialog title="编辑检验检疫货物规格" :visible.sync="goodsInspectionShow" width="60%" :before-close="goodsInspectionClose">
            <el-form :model="decListItem" label-width="200px" size="mini">
                <el-form-item label="成分/原料/组分">
                    <el-input v-model="decListItem.stuff"></el-input>
                </el-form-item>
                <el-form-item label="产品有效期">
                    <el-date-picker v-model="decListItem.prodValidDt" type="date" placeholder="如为进口肉类且存在多个有效期，应填写最早到期的日期"
                    value-format="yyyy-MM-dd" class="width_100"></el-date-picker>
                </el-form-item>
                <el-form-item label="产品保质期(天)">
                    <el-input v-model="decListItem.prodQgp" ></el-input>
                </el-form-item>
                <el-form-item label="境外生产企业">
                    <el-input v-model="decListItem.engManEntCnm" placeholder="进口食品类无需填写"></el-input>
                </el-form-item>
                <el-form-item label="货物规格">
                    <el-input v-model="decListItem.goodsSpec"></el-input>
                </el-form-item>
                <el-form-item label="货物型号">
                    <el-input v-model="decListItem.goodsModel"></el-input>
                </el-form-item>
                <el-form-item label="货物品牌">
                    <el-input v-model="decListItem.goodsBrand" placeholder="用途为&quot;食用&quot;或&quot;化妆品&quot;时,如无品牌,可填&quot;无&quot;"></el-input>
                </el-form-item>
                <el-form-item label="生产批次">
                    <el-input v-model="decListItem.prodBatchNo"></el-input>
                </el-form-item>
                <el-form-item label="生产单位代码">
                    <el-input v-model="decListItem.mnufctrRegNo"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="goodsInspectionClose">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 危险产品信息 -->
         <el-dialog title="编辑危险货物信息" :visible.sync="goodsDangerousShow" width="60%" :before-close="goodsDangerousClose">
            <el-form :model="decListItem" label-width="200px" size="mini">
                <el-form-item label="非危险货物">
                    <el-select class="width_100" filterable :default-first-option="true" placeholder="" v-model="decListItem.noDangFlag">
                        <el-option v-for="item in trueORfalse" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName " :value="item.codeValue">
                            <span class="margin_right_20">{{ item.codeValue }}</span>
                            <span >{{ item.codeName }}</span> 
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="UN编号">
                    <el-input v-model="decListItem.uncode"></el-input>
                </el-form-item>
                <el-form-item label="危险类别">
                    <el-input v-model="decListItem.dangName" ></el-input>
                </el-form-item>
                <el-form-item label="包装类别">
                    <el-select class="width_100" filterable :default-first-option="true" placeholder="" v-model="decListItem.dangPackType">
                        <el-option v-for="item in dangPackTypeList" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName " :value="item.codeValue">
                            <span class="margin_right_20">{{ item.codeValue }}</span>
                            <span >{{ item.codeName }}</span> 
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="包装UN标记">
                    <el-input v-model="decListItem.dangPackSpec"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="goodsDangerousClose">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 商品列表弹窗 -->
        <goodsList @goodsDetails="goodsDetails" ref="goodsList"></goodsList>
        <!-- 集装箱选择商品项号 -->
        <decContainerTable :goodsNoShow="goodsNoShow" :goodsNoList="decList" @goodsNoClose="goodsNoClose"></decContainerTable>
        <!-- 其他包装弹窗、检验检疫 -->
        <packageDialog @packageClose="packageClose" :packageShow="packageShow" :packageCode="packageCode" :exportCode="exportCode"
        :decList="decList"></packageDialog>
        <!-- 文本框弹窗--备注/标记唛码 -->
        <textareaAEO @textareaClose="textareaClose" :textareaShow="textareaShow" :title="title" :textareaValue="textareaValue"></textareaAEO>
        <!-- 企业资质弹框 -->
        <enterprise @enterpriseClose="enterpriseClose" :enterpriseShow="enterpriseShow" :enterpriseCode="enterpriseCode"></enterprise>
        <!-- 特殊业务标识/业务事项 -->
        <specialBusiness @specialBusinessClose="specialBusinessClose" :specialBusinessShow="specialBusinessShow" 
        :specialBusinessType="specialBusinessType" :specialBusinessValue="specialBusinessValue"></specialBusiness>
        <!-- 监管类型名称 -->
        <regulatoryCategory ref="regulatoryCategory" @regulatoryClose="regulatoryClose" ></regulatoryCategory>
        <!-- 价格确认 -->
        <priceDescription @priceClose="priceClose" :priceShow="priceShow"></priceDescription>
        <!-- 货物属性 -->
        <cargoAttributes ref="cargoAttr" @cargoClose="cargoClose" :cargoShow="cargoShow"></cargoAttributes>
        <!-- 上传随附单证 -->
        <uploadDocuments :uploadShow="uploadShow" :id="decHead.id" @uploadClose="uploadClose"></uploadDocuments>
        <!-- 协定享惠 -->
         <decDocXiangHuiContent @xiangHuiContentClose="xiangHuiContentClose" :xiangHuiContentShow="xiangHuiContentShow"></decDocXiangHuiContent>
    </div>
</template>
<script>
import AEODec from '@/config/AEODec.js'
import AEObasicData from '@/config/AEObasicData.js'
import packageDialog from '@/components/AEO/packageDialog.vue'
import textareaAEO from '@/components/AEO/textarea.vue'
import enterprise from '@/components/AEO/enterprise.vue'
import specialBusiness from '@/components/AEO/specialBusiness.vue'
import goodsList from '@/components/AEO/goodsList.vue'
import decContainerTable from '@/components/AEO/decContainerTable.vue'
import regulatoryCategory from '@/components/AEO/regulatoryCategory.vue'
import priceDescription from '@/components/AEO/priceDescription.vue'
import cargoAttributes from '@/components/AEO/cargoAttributes.vue'
import uploadDocuments from '@/components/AEO/uploadDocuments.vue'
import decDocXiangHuiContent from '@/components/AEO/decDocXiangHuiContent.vue'
import { webapp_ws_ajax_run, webapp_urlprotocol_startup, urlAddRandomNo,webapp_ws_autoupdate } from "../../utils/reports/grwebapp";
import currency from 'currency.js'
import clean from 'lodash-clean';
export default {
    components:{
        packageDialog,
        textareaAEO,
        enterprise,
        specialBusiness,
        goodsList,
        decContainerTable,
        regulatoryCategory,
        priceDescription,
        cargoAttributes,
        uploadDocuments,
        decDocXiangHuiContent
    },
    props: {
        exportCode: {
            type: String,
            default: ''
        },
    },
    watch: { 
        exportCode: {
            handler(newVal,oldVal) {
                if(newVal === 'E'){
                    this.decHead.ieFlag = 'E'
                    this.decHead.type = '一般报关单'
                }else if (newVal === 'I'){
                    this.decHead.ieFlag = 'I'
                    this.decHead.type = '一般报关单'
                    // 获取当前日期
                    this.getToday()
                }else if(newVal === 'EML' ){
                    this.decHead.ieFlag = 'E'
                    this.decHead.type = '备案清单'
                }else if(newVal === 'IML'){
                    this.decHead.ieFlag = 'I'
                    this.decHead.type = '备案清单'
                }
            },
            deep: true, // 深度监听
            immediate: true // 立即执行
        },
        // 成交方式
        'decHead.transMode':{
            handler(newVal,oldVal) {
                if(this.exportCode === 'E' || this.exportCode === 'EML'){
                    // 出口
                    if(newVal === '1'){
                        this.feeMarkDis = false
                        this.insurMarkDis = false
                        this.otherMarkDis = false
                    }else if(newVal === '2'){
                        this.feeMarkDis = false
                        this.insurMarkDis = true
                        this.otherMarkDis = false
                        this.decHead.insurMark = ''
                        this.decHead.insurRate = ''
                        this.decHead.insurCurr = ''
                    }else if(newVal === '3'){
                        this.feeMarkDis = true
                        this.insurMarkDis = true
                        this.otherMarkDis = false
                        this.decHead.insurMark = ''
                        this.decHead.insurRate = ''
                        this.decHead.insurCurr = ''
                        this.decHead.feeMark = ''
                        this.decHead.feeRate = ''
                        this.decHead.feeCurr = ''
                    }else if(newVal === '4'){
                        this.feeMarkDis = true
                        this.insurMarkDis = false
                        this.otherMarkDis = false
                        this.decHead.feeMark = ''
                        this.decHead.feeRate = ''
                        this.decHead.feeCurr = ''
                    }else if(newVal === '7'){
                        this.feeMarkDis = true
                        this.insurMarkDis = true
                        this.otherMarkDis = false
                        this.decHead.feeMark = ''
                        this.decHead.feeRate = ''
                        this.decHead.feeCurr = ''
                        this.decHead.insurMark = ''
                        this.decHead.insurRate = ''
                        this.decHead.insurCurr = ''
                        // 弹窗
                        this.$alert('出口成交方式为EXW的报关单需将境内工厂至中华人民共和国境内输出地点装载前的运输及其相关费用、保险费填入杂费栏。', '提示', {
                            confirmButtonText: '确定',
                            callback: action => {  }
                        });
                    }
                    // feeMarkDis:true, // 运费锁定
                    // insurMarkDis:true, // 保费锁定
                    // otherMarkDis:true, // 杂费锁定
                }else{
                    // 进口
                    if(newVal === '1'){
                        this.feeMarkDis = true
                        this.insurMarkDis = true
                        this.otherMarkDis = false
                        this.decHead.feeMark = ''
                        this.decHead.feeRate = ''
                        this.decHead.feeCurr = ''
                        this.decHead.insurMark = ''
                        this.decHead.insurRate = ''
                        this.decHead.insurCurr = ''
                    }else if(newVal === '2'){
                        this.feeMarkDis = true
                        this.insurMarkDis = false
                        this.otherMarkDis = false
                        this.decHead.feeMark = ''
                        this.decHead.feeRate = ''
                        this.decHead.feeCurr = ''
                    }else if(newVal === '3'){
                        this.feeMarkDis = false
                        this.insurMarkDis = false
                        this.otherMarkDis = false
                    }else if(newVal === '4'){
                        this.feeMarkDis = false
                        this.insurMarkDis = true
                        this.otherMarkDis = false
                        this.decHead.insurMark = ''
                        this.decHead.insurRate = ''
                        this.decHead.insurCurr = ''
                    }else if(newVal === '7'){
                        this.feeMarkDis = false
                        this.insurMarkDis = false
                        this.otherMarkDis = false
                    }
                }
            }
        },
        'decHead.feeMark':{  // 运费
            handler(newVal,oldVal) {
                if(newVal === ''){
                    this.decHead.feeRate = ''
                    this.decHead.feeCurr = ''
                }else if (newVal === '1') {
                    this.decHead.feeCurr = ''
                }
            },
        },
        'decHead.insurMark':{  // 保险费
            handler(newVal,oldVal) {
                if(newVal === ''){
                    this.decHead.insurRate = ''
                    this.decHead.insurCurr = ''
                }else if (newVal === '1') {
                    this.decHead.insurCurr = ''
                }
            },
        },
        'decHead.otherMark':{  // 杂费
            handler(newVal,oldVal) {
                if(newVal === ''){
                    this.decHead.otherRate = ''
                    this.decHead.otherCurr = ''
                }else if (newVal === '1') {
                    this.decHead.otherCurr = ''
                }
            },
        },
        'decHead.netWt':{  // 净重
            handler(newVal,oldVal) {
                if(Number(newVal) > Number(this.decHead.grossWet)){
                    this.$message({
                        message: '净重必须小于等于毛重',
                        type: 'warning'
                    });
                }
            },
        },
        'decHead.grossWet':{  // 毛重
            handler(newVal,oldVal) {
                if(Number(newVal) < Number(this.decHead.netWt)){
                    this.$message({
                        message: '净重必须小于等于毛重',
                        type: 'warning'
                    });
                }
            },
        },
        // 监管方式
        'decHead.tradeMode':{
            handler(newVal,oldVal) {
                if(newVal === '0110'){
                    this.decHead.cutMode = '101'
                }else if(newVal === '5034'){
                    this.decHead.cutMode = ''
                }else if(newVal === '0615'){
                    this.decHead.cutMode = '503'
                }
            },
        },
        decList:{
            handler(newVal,oldVal) {
                if(newVal.length){
                    this.tipsTotal.allTotal = 0 // 所有总价
                    this.tipsTotal.allGqty = 0 // 成交数量所有合计
                    this.tipsTotal.allFirstQty = 0 // 法定第一数量所有合计
                    this.tipsTotal.allSecondQty = 0 // 法定第二数量所有合计
                    this.tipsTotal.allWeightKG = 0 // 重量合计  只加gUnit为035的值,如果gUnit 不等于KG，判断法一，法一不是KG判断法二
                    // 有商品值
                    // { type:'',total:0}
                    const gQtyMap = new Map() // 成交数量
                    const firstQtyMap = new Map() // 法定第一数量
                    const secondQtyMap = new Map() // 法定第二数量
                    const tradeCurrMap = new Map() // 币制合计
                    // 总价 :所有总价的和
                    newVal.forEach(item => {
                        // 3. 检查当前 单位 是否已存在于 Map 中
                        // 成交数量
                        const unitKey = String(item.gUnit).trim();
                        if (gQtyMap.has(item.gUnit)) { // 成交数量列表,查成交单位
                            // 4. 如果存在：取出对应的值，将其 合计 累加当前 item
                            gQtyMap.get(item.gUnit).total += Number(item.gQty);
                        } else {
                            // 5. 如果不存在：将当前 item 的副本存入 Map，键为 item.type
                            gQtyMap.set(unitKey, { type: item.gUnit, total: Number(item.gQty) });
                        }
                        // 法定第一数量
                        const unitFKey = String(item.firstUnit).trim();
                        if (firstQtyMap.has(item.firstUnit)) { // 法定第一数量列表,查法定第一计量单位
                            firstQtyMap.get(item.firstUnit).total += Number(item.firstQty);
                        } else {
                            firstQtyMap.set(unitFKey, { type: item.firstUnit, total: Number(item.firstQty) });
                        }
                        // 法定第二数量
                        const unitSKey = String(item.secondUnit).trim();
                        if (secondQtyMap.has(item.secondUnit)) { // 法定第二数量列表,查法定第二计量单位
                            secondQtyMap.get(item.secondUnit).total += Number(item.secondQty);
                        } else {
                            secondQtyMap.set(unitSKey, { type: item.secondUnit, total: Number(item.secondQty) });
                        }
                        // 币制合计
                        const currKey = String(item.tradeCurr).trim();
                        if (tradeCurrMap.has(item.tradeCurr)) { // 币制列表,查币制,算总价
                            tradeCurrMap.get(item.tradeCurr).total += Number(item.declTotal);
                        } else {
                            tradeCurrMap.set(currKey, { type: item.tradeCurr, total: Number(item.declTotal) });
                        }
                        // 重量 035 千克
                        if(item.gUnit === '035'){
                            this.tipsTotal.allWeightKG += Number(item.gQty);
                        }else if( item.firstUnit === '035'){
                            // 判断法一是不是Kg
                            this.tipsTotal.allWeightKG += Number(item.firstQty);
                        }else if(item.secondUnit === '035'){
                            this.tipsTotal.allWeightKG += Number(item.secondQty);
                        }
                        this.tipsTotal.allTotal = currency(this.tipsTotal.allTotal,{precision: 4}).add(item.declTotal).value // 不分币制,所有总价的和
                        this.tipsTotal.allGqty = currency(this.tipsTotal.allGqty,{precision: 4}).add(item.gQty).value // 成交数量所有合计
                        this.tipsTotal.allFirstQty = currency(this.tipsTotal.allFirstQty,{precision: 4}).add(item.firstQty).value // 法定第一数量所有合计
                        this.tipsTotal.allSecondQty = currency(this.tipsTotal.allSecondQty,{precision: 4}).add(item.secondQty).value // 法定第二数量所有合计
                    });
                    this.tipsTotal.gQtyMap = Array.from(currency(gQtyMap.values()).value)
                    this.tipsTotal.firstQtyMap = Array.from(currency(firstQtyMap.values()).value)
                    this.tipsTotal.secondQtyMap = Array.from(currency(secondQtyMap.values()).value)
                    this.tipsTotal.tradeCurrMap = Array.from(currency(tradeCurrMap.values()).value)
                    this.tipsTotal.allWeightKG = currency(this.tipsTotal.allWeightKG, { precision: 4 }).value;
                }
            },
            deep: true, // 深度监听
            immediate: true // 立即执行
        }
    },
    data() {
        return {
            localStorageName:localStorage.getItem('name'),// 当前登录人名称
            packageShow:false, // 其他包装弹窗
            packageCode:0, // 0 包装信息  1 检验检疫签证申报要素
            textareaShow:false, // 描述弹窗--备注/标记唛码
            title:'',// 描述标题
            textareaValue:'',// 描述内容
            enterpriseShow:false, // 企业资质弹窗/使用人信息
            enterpriseCode:0, // 0 企业资质  1 使用人信息
            specialBusinessShow:false, // 特殊业务标识/价格说明/业务事项 弹窗
            specialBusinessType:0, // 0：特殊业务标识  1业务事项
            specialBusinessValue:'', // 回显值,
            priceShow:false, // 价格确认弹窗
            xiangHuiContentShow:false, // 协定享惠弹窗
            form_top_code:false,
            form_bottom_code:false,
            type: '', // 是否是备案清单
            inputCode:false, // 当状态是审结，放行，结关，查验时禁止填写
            input:'',
            customsList:[], //海关列表
            countryList: [], // 国家
            harborList: [], // 港口
            seaportList: [], // 离境口岸列表
            transportModeList:AEObasicData.CUS_MAPPING_TRANSPORT_CODE_V, // 运输方式
            superviseList:AEObasicData.CUS_MAPPING_TRADE_CODE_V, // 监管方式/贸易方式
            exemptionNatureList: AEObasicData.CUS_LEVYTYPE, // 征免性质
            enterpriseList:[], // 企业列表
            CUSTransacList:AEObasicData.CUSTransac, // 成交方式
            packageList:AEObasicData.CUS_MAPPING_PACKAGEKIND_CODE_V, // 包装种类
            listType:AEObasicData.DEC_BILL_TYPE,// 清单类型
            CUSDeclarationList:AEObasicData.DEC_ENTRY_TYPE,// 报关单类型
            trueORfalse:AEObasicData.trueORfalse, // 是/否
            currencyList: AEObasicData.CUS_MAPPING_CURRENCY_CODE_V, // 币制
            origPlaceCodeList:[], //产地代码
            domesticDestinationList:[],// 境内货源地/目的地
            dutyModeList:AEObasicData.CUS_LEVYMODE, // 征免方式
            purposeList: AEObasicData.CIQ_USE, // 用途
            feeMarkList:AEObasicData.feeMarkList, // 运费标志
            otherCostMarkList:AEObasicData.otherCostMarkList, // 其他费标志
            unitList: [], // 计量单位列表
            decHead:AEODec.deHead, // 表头
            decList:[],
            decListItem:JSON.parse(JSON.stringify(AEODec.decListItem)),// 表体 
            goodsInspectionShow:false, // 商品检验检疫弹窗
            // 表头必填
            decHeadRules:AEODec.decHeadRules,
            // 表体必填
            decListItemRules:AEODec.decListItemRules,
            selectGoosd:{}, // 选中的表格数据,只能单选
            decContainerItem: JSON.parse(JSON.stringify(AEODec.decContainer)),// 集装箱详情
            decContainer:[],// 集装箱表格
            containersMDList:AEObasicData.CUS_MAPPING_NORMS_CODE, // 集装箱规格列表
            decContainerRules: AEODec.decContainerRules, // 集装箱必填
            goodsNoShow:false, // 商品项号关联弹窗
            cargoShow:false, // 商品货物属性弹窗
            goodsDangerousShow:false, // 危险货物信息
            dangPackTypeList:AEObasicData.CIQ_DANGER_PACK_TYPE,// 包装类别
            decContainerSelect:{},// 选中的集装箱数据
            tipsTotal:{},// 总计
            documentationList:AEObasicData.CUS_LICENSEDOCU,// 随附单证代码
            decLicenseDocus:[], // 随附单证列表
            decLicenseDocusItem:AEODec.decLicenseDocus, // 随附单证详情
            decLicenseDocusSelect:{},// 选中的随附单证数据
            decLicenseDocusRules:AEODec.decLicenseDocusRules,
            // 上传随附单证弹窗
            uploadShow:false,
            feeMarkDis:true, // 运费锁定
            insurMarkDis:true, // 保费锁定
            otherMarkDis:true, // 杂费锁定
            importDetailAction:process.env.VUE_APP_BASE_API + 'cms/declare/importDetail',// 商品导入路径
            importDetailFile:[], // 商品导入文件
            headers:{ // 导入文件token
                'token': localStorage.getItem('token')
            }
        }
    },
    created() {
        // 配置currency.js全局设置
        currency.settings = {
            precision: 4,
            decimal: '.',
            separator: ',',
            symbol: ''
        };
    },
    mounted() { 
        this.getCountryList(this.decListItem.destinationCountry)
    },
    methods: { 
        // 如果有id则回显
        getdeclareDetails(id,ifCopy,entryNo,seqNo){// ifCopy 是否是复制,是复制新建的话清除id
            if(id){ 
                this.$api.getDetailById(id).then(res => { 
                    this.decHead = res.decHead
                    this.decList = res.decList
                    this.decListItem.gNo = res.decList.length + 1
                    if(!ifCopy){
                        // 不是复制
                        // 不是初审人不可编辑
                        if(this.decHead.status === '审结' || this.decHead.status === '放行' || this.decHead.status === '结关' || this.decHead.status === '查验' || this.decHead.inputerName !== this.localStorageName ){
                            // 不可编辑
                            this.inputCode = true
                        }else{
                            this.inputCode = false
                        }
                        // 集装箱和单证
                        this.decContainer = res.decContainer
                        this.decLicenseDocus = res.decLicense.map((item,index) =>{
                            return { licenseNum:index+1,...item}
                        })
                        // 不是复制新建赋值统一编号和海关编号
                        this.decHead.entryNo = entryNo
                        this.decHead.seqNo = seqNo
                        this.decHead.checker = this.decHead.checker?this.decHead.checker:''
                    }else{
                        // 是复制
                        this.inputCode = false
                        // this.decHead.status = ''
                        // 清除id
                        this.decHead.id = ''
                        this.decHead.seqNo = ''
                        this.decHead.entryNo = ''
                        this.decHead.ieDate = ''
                        // this.decHead.createTime = ''
                        delete this.decHead.createTime
                        // this.decHead.modifyDate = ''
                        delete this.decHead.modifyDate
                        // 清除审核人
                        this.decHead.inputerName = ''
                        this.decHead.checker = ''
                        // 清除放行日期
                        this.decHead.entryDate = null
                        // 清除状态
                        this.decHead.status = null
                        // 创建时间之类的
                        // 表体清除id
                        this.decList.map(item =>{
                            item.id = ''
                            item.interId = ''
                            item.entryDate = ''
                            return{...item}
                        })
                    }

                    // 表头
                    // 申报地海关/出境关别
                    this.customsList = AEObasicData.CUS_CUSTOMS.filter(item =>
                        item.codeValue.toLowerCase().includes(res.decHead.customMaster.toLowerCase()) ||
                        item.codeValue.toLowerCase().includes(res.decHead.iePort.toLowerCase())
                    );
                    // 运抵国、贸易国别(地区)
                    this.countryList = AEObasicData.CUS_MAPPING_COUNTRY_CODE_V.filter(item =>
                        item.codeValue.toLowerCase().includes(res.decHead.tradeCountry.toLowerCase()) ||
                        item.codeValue.toLowerCase().includes(res.decHead.tradeAreaCode.toLowerCase())
                    );
                    // 指运港
                    if(this.exportCode === 'I' || this.exportCode === 'IML'){
                        this.harborList = AEObasicData.CUS_MAPPING_PORT_CODE_V.filter(item =>
                            item.codeValue.toLowerCase().includes(res.decHead.distinatePort.toLowerCase()) || 
                            item.codeValue.toLowerCase().includes(res.decHead.despPortCode.toLowerCase())
                        );
                    }else{
                        this.harborList = AEObasicData.CUS_MAPPING_PORT_CODE_V.filter(item =>
                            item.codeValue.toLowerCase().includes(res.decHead.distinatePort.toLowerCase())
                        );
                    }
                    
                    // 离境口岸
                    this.seaportList = AEObasicData.CIQ_PORT_CN.filter(item =>
                        item.codeValue.toLowerCase().includes(res.decHead.entyPortCode.toLowerCase())
                    );

                    //箱型加序号,排列
                    this.decContainer.forEach((item, index) => {
                        item.containerNum = index + 1;
                    });
                })
            }else{
                const initialData = this.$options.data.call(this); // 获取初始数据
                Object.keys(initialData).forEach(key => {
                    this[key] = initialData[key]; // 逐字段重置
                });
                this.$forceUpdate()
                this.$refs.decHead.resetFields();
            }
        },
        // 获取当前日期
        getToday(){
            const today = new Date();
            const year = today.getFullYear();  // 获取年份（如 2025）
            const month = String(today.getMonth() + 1).padStart(2, '0');  // 月份补零（如 "09"）
            const day = String(today.getDate()).padStart(2, '0');         // 日期补零（如 "10"）
            const dateString = `${year}${month}${day}`;
            this.decHead.ieDate = dateString
        },
        // 过滤国家列表
        getCustomsList(value){
            if(value && value !== ' '){
                this.customsList = AEObasicData.CUS_CUSTOMS.filter(item =>
                    item.codeName.toLowerCase().includes(value.toLowerCase()) ||
                    item.codeValue.toLowerCase().includes(value.toLowerCase())
                );
            }
        },
        // 过滤港口信息
        getHarborList(value){
            if(value && value !== ' '){
                this.harborList = AEObasicData.CUS_MAPPING_PORT_CODE_V.filter(item =>
                    item.codeValue.toLowerCase().includes(value.toLowerCase()) ||
                    item.codeName.toLowerCase().includes(value.toLowerCase()) ||
                    item.cusCode.toLowerCase().includes(value.toLowerCase())
                );
            }
        },
        // 过滤国家地区
        getCountryList(value){
            if(value && value !== ' '){
                this.countryList = AEObasicData.CUS_MAPPING_COUNTRY_CODE_V.filter(item =>
                    item.codeValue.toLowerCase().includes(value.toLowerCase()) ||
                    item.codeName.toLowerCase().includes(value.toLowerCase()) || 
                    item.cusCode.toLowerCase().includes(value.toLowerCase())
                );
            }
        },
        // 过滤离境口岸
        getSeaportList(value){
            if(value && value !== ' '){
                this.seaportList = AEObasicData.CIQ_PORT_CN.filter(item =>
                    item.codeValue.toLowerCase().includes(value.toLowerCase()) ||
                    item.codeName.toLowerCase().includes(value.toLowerCase())
                );
            }
        },
        // 过滤境内目的地
        getDomesticDestinationList(value){ 
            if(value && value !== ' '){
                this.domesticDestinationList = AEObasicData.CUS_DISTRICT.filter(item =>
                    item.codeValue.toLowerCase().includes(value.toLowerCase()) ||
                    item.codeName.toLowerCase().includes(value.toLowerCase())
                );
            }
        },
        // 过滤产地列表
        getOrigPlaceCodeList(value){
            if(value && value !== ' '){
                this.origPlaceCodeList = AEObasicData.CIQ_CITY_CN.filter(item =>
                    item.codeValue.toLowerCase().includes(value.toLowerCase()) ||
                    item.codeName.toLowerCase().includes(value.toLowerCase())
                );
            }
        },
        // 过滤计量单位
        getUnitList(value){
            if(value && value !== ' '){
                this.unitList = AEObasicData.CUS_UNIT.filter(item =>
                    item.codeValue.toLowerCase().includes(value.toLowerCase()) ||
                    item.codeName.toLowerCase().includes(value.toLowerCase())
                );
            }
        },
        // 选择后列表置空
        emptyList(value,code){
            if(code === 'customMaster'){
                this.decHead.customMaster = value
                this.customsList = []
            }else if( code === 'distinatePort'){
                this.decHead.distinatePort = value
                this.harborList = []
            }else if( code === 'tradeAreaCode'){
                this.decHead.tradeAreaCode = value
                this.countryList = []
            }else if(code === 'entyPortCode'){
                this.decHead.entyPortCode = value
                this.seaportList = []
            }else if(code === 'districtCode'){
                this.decHead.districtCode = value
                this.domesticDestinationList = []
            }else if(code === 'origPlaceCode'){
                this.decHead.origPlaceCode = value
                this.origPlaceCodeList = [] 
            }else if(code === 'gUnit'){ 
                // 成交计量单位
                this.decListItem.gUnit = value
                this.unitList = []
                // 判断成交计量单位与法定第一计量单位是否相同
                if(this.decListItem.gUnit === this.decListItem.firstUnit){ 
                    // 相同的话,成交数量===法定第一数量
                    if(this.decListItem.gQty !== this.decListItem.firstQty){
                        // 如果数量不相同，以成交数量为准
                        this.decListItem.firstQty = this.decListItem.gQty
                    }
                }
            }else if(code === 'purpOrgCode'){
                this.customsList = []
                this.decHead.purpOrgCode = value
            }else if(code === 'iePort'){
                this.customsList = []
                this.decHead.iePort = value
            }else if(code === 'originCountry'){
                this.countryList = []
                this.decListItem.originCountry = value
            }else if(code === 'destinationCountry'){
                this.countryList = []
                this.decListItem.destinationCountry = value
            }else if(code === 'despPortCode'){
                this.harborList = []
                this.decHead.despPortCode = value
            }else if(code === 'destCode'){
                this.origPlaceCodeList = []
                this.decHead.destCode = value
            }
        },
        // 获取企业列表
        getEnterpriseList(value){
            this.$api.getCompanyList(  {companyName:value } ).then(res =>{
                this.enterpriseList = res.tableData
            })
        },
        // 选择企业后带出海关编码和信用代码
        enterpriseChange(value,code){
            const item  = value.split('-')
            if(code === 'Agent'){
                this.decHead.agentCode = item[1]
                this.decHead.agentCodeScc = item[2]
                this.decHead.agentName = item[0]
            }else if(code === 'Owner'){
                this.decHead.ownerName = item[0]
                this.decHead.ownerCode = item[1]
                this.decHead.ownerCodeScc = item[2]
            }else if( code === 'Trade'){
                this.decHead.tradeCode = item[1]
                this.decHead.tradeCoScc = item[2]
                this.decHead.tradeName = item[0]
            }
            this.enterpriseList = []
        },
        // 企业名称可选可填
        selectBlur(e,code) {
            if (e.target.value !== '') {
                if(code === 'tradeName'){
                    this.decHead.tradeName = e.target.value;
                }else if(code === 'ownerName'){
                    this.decHead.ownerName = e.target.value;
                }else if(code === 'dclEtpsNm'){
                    this.decHead.dclEtpsNm = e.target.value;
                }
                this.$forceUpdate();   // 强制更新
            }
        },
        // 输入商品编号后回车
        goodsCodeEnter(){
            if( this.decListItem.codeTs && this.decListItem.codeTs !== ' ' ){
                this.$refs['goodsList'].getGoodsList(this.decListItem.codeTs)
            }
        },
        // 重新归类
        newClassify(exit){
            if(this.decListItem.codeTs ){
                this.$refs['goodsList'].sureGoods('0',exit,this.decListItem.codeTs,this.decListItem.gModel)
            }else{
                this.$message({
                    type: 'error',
                    message: '请输入商品编号'
                });
            }
        },
        // 确认商品申报要素
        goodsDetails(type,detail,inputCode){
            // 重新归类,只更新规格型号
            this.decListItem.gModel = inputCode
            if(type === '1'){ // 编辑全部更新W
                this.decListItem.codeTs = detail.hsCode
                // this.decListItem.gName = detail.hsName
                // 检测商品计量单位有几个
                if(detail.hsUnit.includes('/')){ // 有两个计量单位
                    const firstUnitCode = AEObasicData.CUS_UNIT.filter(item =>
                        item.codeName.toLowerCase().includes(detail.hsUnit.split('/')[0])
                    );
                   const secondUnitCode = AEObasicData.CUS_UNIT.filter(item =>
                        item.codeName.toLowerCase().includes(detail.hsUnit.split('/')[1])
                    );
                    this.decListItem.firstUnit = firstUnitCode[0].codeValue
                    this.decListItem.secondUnit = secondUnitCode[0].codeValue
                    this.unitList.push(firstUnitCode[0])
                    this.unitList.push(secondUnitCode[0])
                }else{
                    const firstUnitCode = AEObasicData.CUS_UNIT.filter(item =>
                        item.codeName.toLowerCase().includes(detail.hsUnit)
                    );
                    this.decListItem.firstUnit = firstUnitCode[0].codeValue
                    this.decListItem.secondUnit = ''
                    this.decListItem.secondQty = ''
                    this.unitList.push(firstUnitCode[0])
                }
                this.decListItem.gUnit = this.decListItem.firstUnit
            }
        },
        // 输入单价\总价自动计算
        inputPprice(code){
            if(this.decListItem.gQty){ // 判断是否输入成交数量
                if(code === 'declPrice'){ // 输入单价,计算总价
                    this.decListItem.declTotal = Number(this.decListItem.gQty) * Number(this.decListItem.declPrice)
                    this.decListItem.declTotal = Number(this.decListItem.declTotal).toFixed(2)
                }else{
                    this.decListItem.declPrice = Number(this.decListItem.declTotal) / Number(this.decListItem.gQty)
                    this.decListItem.declPrice = Number(this.decListItem.declPrice).toFixed(4)
                }
            }
        },
        // 输入成交数量校验 商品单价,总价
        priceCount(code){
            if(code === 'gQty'){
                if(this.decListItem.gQty && this.decListItem.declPrice && this.decListItem.declTotal){
                // 都填写后
                    var total = Number(this.decListItem.gQty) * Number(this.decListItem.declPrice)
                    total = Number(total).toFixed(2)
                    var declTotal = Number(this.decListItem.declTotal).toFixed(2)
                    if( declTotal !== total){
                        this.$confirm('报关修改单价/总价?', '提示', {
                            confirmButtonText: '修改单价',
                            cancelButtonText: '修改总价',
                            type: 'warning',
                            closeOnClickModal:false,
                            closeOnPressEscape:false,
                            showClose:false
                        }).then(() => {
                            // 修改单价
                            this.decListItem.declPrice = Number(this.decListItem.declTotal) / Number(this.decListItem.gQty)
                            this.decListItem.declPrice = Number(this.decListItem.declPrice).toFixed(4)
                        }).catch(() => {
                            // 修改总价
                            this.decListItem.declTotal = Number(this.decListItem.gQty) * Number(this.decListItem.declPrice)
                            this.decListItem.declTotal = Number(this.decListItem.declTotal).toFixed(2)
                        });
                }
                }else if(this.decListItem.gQty && this.decListItem.declPrice){ // 直接计算总价
                    this.decListItem.declTotal = Number(this.decListItem.gQty) * Number(this.decListItem.declPrice)
                    this.decListItem.declTotal = Number(this.decListItem.declTotal).toFixed(2)
                }else if(this.decListItem.gQty && this.decListItem.declTotal){ // 改单价
                    this.decListItem.declPrice = Number(this.decListItem.declTotal) / Number(this.decListItem.gQty)
                    this.decListItem.declPrice = Number(this.decListItem.declPrice).toFixed(4)
                }
            }
            // 判断成交计量单位与法定第一计量单位是否相同
            if(this.decListItem.gUnit === this.decListItem.firstUnit){ 
                // 相同的话,成交数量===法定第一数量
                if(this.decListItem.gQty !== this.decListItem.firstQty){
                    // 如果数量不相同
                    if(code === 'gQty'){
                        this.decListItem.firstQty = this.decListItem.gQty;
                    }else{
                        this.decListItem.gQty = this.decListItem.firstQty;
                    }
                }
            }
        },
        // 征免方式回车添加到表格中
        addGoosdList(){
            this.$refs.decListItem.validate((valid) => {
                if (valid) {
                    var item = JSON.parse(JSON.stringify(this.decListItem))
                    // 判断是修改还是新增
                    if(this.decList.length >= this.decListItem.gNo){
                        // 修改
                        const updataNum = item.gNo - 1
                        this.$set(this.decList, updataNum , item);
                    }else{
                        // 新增
                        this.decList.push(item)
                    }
                        this.decListItem = JSON.parse(JSON.stringify(AEODec.decListItem))
                        this.decListItem.gNo = this.decList.length + 1
                        this.decListItem.gUnit = item.gUnit
                        this.decListItem.tradeCurr = item.tradeCurr
                        this.decListItem.destinationCountry = item.destinationCountry
                        this.decListItem.originCountry = item.originCountry
                        this.decListItem.districtCode = item.districtCode
                        this.decListItem.dutyMode = item.dutyMode
                        this.$message({
                            message: '添加/修改成功',
                            type: 'success'
                        });
                }else {
                    this.$message({
                        message: '请填写必填项',
                        type: 'warning'
                    });
                    return false;
                }
            })
        },
        // 选中表格中数据回显
        goodsDetailsShow(val){
            if(val){
                this.decListItem = JSON.parse(JSON.stringify(val))
                this.decListItem.dutyMode = "" + this.decListItem.dutyMode
                this.selectGoosd = JSON.parse(JSON.stringify(val))
                // 查询成交计量单位，法一，最终目的国，原产国，境内货源地，产地
                this.unitList = AEObasicData.CUS_UNIT.filter(item =>{
                    const gUnit = (this.decListItem.gUnit || '').toLowerCase();
                    const firstUnit = (this.decListItem.firstUnit || '').toLowerCase();
                    const secondUnit = (this.decListItem.secondUnit || '').toLowerCase();
                    return (
                        item.codeValue.toLowerCase().includes(gUnit) ||
                        item.codeValue.toLowerCase().includes(firstUnit) ||
                        item.codeValue.toLowerCase().includes(secondUnit)
                    );
                }
                 
                    // item.codeValue.toLowerCase().includes(this.decListItem.gUnit.toLowerCase()) ||
                    // item.codeValue.toLowerCase().includes(this.decListItem.firstUnit.toLowerCase()) || 
                    // item.codeValue.toLowerCase().includes(this.decListItem.secondUnit.toLowerCase())
                );
                this.countryList = AEObasicData.CUS_MAPPING_COUNTRY_CODE_V.filter(item =>
                    item.codeValue.toLowerCase().includes(this.decListItem.originCountry.toLowerCase()) || 
                    item.codeValue.toLowerCase().includes(this.decListItem.destinationCountry.toLowerCase())
                );
                this.domesticDestinationList = AEObasicData.CUS_DISTRICT.filter(item =>
                    item.codeValue.toLowerCase().includes(this.decListItem.districtCode.toLowerCase())
                );
                // 境内目的地和原产地区，如果有就查，没有就不查
                if(this.decListItem.origPlaceCode){
                    this.origPlaceCodeList = AEObasicData.CIQ_CITY_CN.filter(item =>
                        item.codeValue.toLowerCase().includes(this.decListItem.origPlaceCode.toLowerCase())
                    );
                }
                if(this.decListItem.destCode){
                    this.origPlaceCodeList = AEObasicData.CIQ_CITY_CN.filter(item =>
                        item.codeValue.toLowerCase().includes(this.decListItem.destCode.toLowerCase())
                    );
                }
                if(this.decListItem.origPlaceCode && this.decListItem.destCode){
                    this.origPlaceCodeList = AEObasicData.CIQ_CITY_CN.filter(item =>
                        item.codeValue.toLowerCase().includes(this.decListItem.origPlaceCode.toLowerCase()) || 
                        item.codeValue.toLowerCase().includes(this.decListItem.destCode.toLowerCase())
                    );
                }
            }
        },
        // 删除商品详情信息
        deleteGoodsDetails(){
            if(this.selectGoosd.gNo){
                this.$confirm('是否确认删除商品表体数据？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const index = this.selectGoosd.gNo-1
                    this.decList.splice(index, 1)
                    // 重新排序
                    this.tableGNoSort('decList')
                    // 商品详细信息更新
                    this.addGoodsList()
                }).catch(() => {
                    return false          
                });
            }else{
                this.$message({
                    message: '请先选中数据!',
                    type: 'warning'
                });
            }
        },
        // 商品列表新增一行
        addGoodsList(){
            // 取消表格选中
            this.selectGoosd = {}
            this.$refs.decList.setCurrentRow() // 取消高亮
            this.decListItem = JSON.parse(JSON.stringify(AEODec.decListItem))
            // 列表最后一行数据,列表有数据的话
            if( this.decList.length ){
                const endItem = this.decList.length-1
                this.decListItem.gNo = this.decList.length + 1
                this.decListItem.gUnit = this.decList[endItem].gUnit
                this.decListItem.tradeCurr = this.decList[endItem].tradeCurr
                this.decListItem.destinationCountry = this.decList[endItem].destinationCountry
                this.decListItem.originCountry = this.decList[endItem].originCountry
                this.decListItem.districtCode = this.decList[endItem].districtCode
                this.decListItem.dutyMode = this.decList[endItem].dutyMode
            }
        },
        // 商品表格数据重新排序
        tableGNoSort(code){
            if(code === 'decList'){
                this.decList.forEach((item, index) => {
                    item.gNo = index + 1;
                });
            }else if(code === 'decContainer'){
                this.decContainer.forEach((item, index) => {
                    item.containerNum = index + 1;
                });
            }else if(code === 'decLicenseDocus'){
                this.decLicenseDocus.forEach((item, index) => {
                    item.licenseNum = index + 1;
                });
            }
            
        },
        // 商品列表上下移动
        moveGoodsList(code){
            // 判断是否选中
            if(this.selectGoosd.gNo){
                if(code === 'top'){ // 上移,如果是第一行则不动
                    if(this.selectGoosd.gNo !== 1){ // 向上移动
                        const index = this.selectGoosd.gNo - 1
                        // 临时存储当前元素的 gNo
                        const currentGNo = this.decList[index].gNo
                        const prevGNo = this.decList[index - 1].gNo
                        // 交换除 gNo 外的其他字段
                        const temp = { ...this.decList[index - 1], gNo: currentGNo }
                        this.$set(this.decList, index - 1, { ...this.decList[index], gNo: prevGNo })
                        this.$set(this.decList, index, temp)
                        // 继续选中上移的数据
                        this.selectGoosd = this.decList[index-1]
                        this.$refs.decList.setCurrentRow(this.decList[index-1])
                    }else{
                        this.$message({
                            message: '已经是第一条数据!',
                            type: 'warning'
                        });
                    }
                }else{
                    if(this.selectGoosd.gNo !== this.decList.length){
                        const index = this.selectGoosd.gNo - 1
                        // 临时存储当前元素的 gNo
                        const currentGNo = this.decList[index].gNo
                        const prevGNo = this.decList[index + 1].gNo
                        // 交换除 gNo 外的其他字段
                        const temp = { ...this.decList[index + 1], gNo: currentGNo }
                        this.$set(this.decList, index + 1, { ...this.decList[index], gNo: prevGNo })
                        this.$set(this.decList, index, temp)
                        // 继续选中下移的数据
                        this.selectGoosd = this.decList[index+1]
                        this.$refs.decList.setCurrentRow(this.decList[index+1])
                        // this.selectGoosd = {}
                        // this.$refs.decList.setCurrentRow()
                    }else{
                        this.$message({
                            message: '已经是最后一条数据!',
                            type: 'warning'
                        });
                    }
                }
            }else{
                this.$message({
                    message: '请先选中数据!',
                    type: 'warning'
                });
            }
        },
        // 复制选中商品
        copyGoods(){
            if(this.selectGoosd.gNo){
                this.selectGoosd.gNo  = this.decList.length + 1
                const item = JSON.parse(JSON.stringify(this.selectGoosd))
                this.decList.push(item)
                // 清空选中数据
                this.selectGoosd = {}
                this.$refs.decList.setCurrentRow()
            }else{
                this.$message({
                    message: '请先选中数据!',
                    type: 'warning'
                });
            }
        },
        // 打开选择商品项号
        goodsNoChange(){
            if( this.decList.length){
                this.goodsNoShow = true
            }
        },
        // 关闭选择商品项号
        goodsNoClose(goodsNo){
            this.goodsNoShow = false
            this.decContainerItem.goodsNo = goodsNo
            this.addDecContainer()
        },
        // 关闭商品检验检疫弹窗
        goodsInspectionClose(){
            this.goodsInspectionShow = false
        },
        // 关闭商品危险货物信息
        goodsDangerousClose(){
            this.goodsDangerousShow =false
        },
        // 检测集装箱号是否重复
        repeatId(){
            var repeatCode = false // 是否重复
            var exitIndex = 0 // 修改行数
            // 判断是新增还是修改
            if(this.decContainerItem.containerNum <= this.decContainer.length){ // 修改
                exitIndex = this.decContainerItem.containerNum 
            }else{ // 新增
                // 判断是否重复
                var repeatList =  this.decContainer.filter(item => item.containerId === this.decContainerItem.containerId);
                if(repeatList.length){
                    repeatCode = true
                }
            }
            if(repeatCode){
                this.$message.error('集装箱号不能重复！')
            }
            // false:没重复;true:重复
            return {repeatCode:repeatCode,exitIndex:exitIndex} // exitIndex最小是1
        },
        // 点击按钮或选择商品项号后 添加集装箱表格
        addDecContainer(){
            this.$refs.decContainerItem.validate((valid) => {
                if (valid) {
                    var { repeatCode,exitIndex } = this.repeatId()
                    if(repeatCode){
                        return false
                    }else{
                        var item = JSON.parse(JSON.stringify(this.decContainerItem))
                        // 校验是否是十一位箱号
                        if (!(/^[A-Za-z]{4}[0-9]{7}$/.test(item.containerId))) {
                            // 校验失败
                            this.$message({
                                message: '请填写正确箱号,前四位字母，后七为数字',
                                type: 'warning'
                            });
                            return false
                        } 
                        // 判断是修改还是新增
                        if(exitIndex){
                            // 有值就是修改
                            this.$set(this.decContainer, exitIndex - 1, item);
                        }else{
                            this.decContainer.push(item)
                        }
                        this.decContainerItem = JSON.parse(JSON.stringify(AEODec.decContainer))
                        this.decContainerItem.containerNum = this.decContainer.length+1
                    }
                }else {
                    this.$message({
                        message: '请填写必填项',
                        type: 'warning'
                    });
                    return false;
                }
            })
        },
        // 新增新集装箱
        addDecContainerItem(){
            this.decContainerItem = JSON.parse(JSON.stringify(AEODec.decContainer))
            this.decContainerItem.containerNum = this.decContainer.length+1
            // 清空表格选中数据
            this.decContainerSelect = {}
            this.$refs.decContainer.setCurrentRow();
        },
        // 删除集装箱数据
        delDecContainerItem(){
            if(this.decContainerSelect){
                this.$confirm('是否确认删除集装箱数据？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const index = this.decContainerSelect.containerNum-1
                    this.decContainer.splice(index, 1)
                    // 重新排序
                    this.tableGNoSort('decContainer')
                    // 商品详细信息更新
                    this.addDecContainerItem()
                }).catch(() => {
                    return false          
                });
            }else{
                this.$message({
                    message: '请选中数据',
                    type: 'warning'
                });
            }
        },
        // 选择集装箱列表中数据显示在详情中
        decContainerShow(val){
            if(val){
                this.decContainerItem = JSON.parse(JSON.stringify(val))
                // 选中数据赋值
                this.decContainerSelect = JSON.parse(JSON.stringify(val))
            }
        },
        formTopCode(){
            this.form_top_code = !this.form_top_code;
        },
        formBottomCode(){
            this.form_bottom_code = !this.form_bottom_code;
        },
        // 打开其他包装弹窗
        packageOpen(code){
            this.packageCode = code; // 0 包装信息  1 检验检疫签证申报要素
            this.packageShow = true;
        },  
        // 关闭其他包装弹窗
        packageClose(){
            this.packageShow = false
        },
        // 打开备注/标记唛码弹窗
        textareaOpen(title,textareaValue){
            this.textareaShow = true
            this.title = title
            this.textareaValue = textareaValue
        },
        textareaClose(){
            this.textareaShow = false
        },
        // 企业资质弹窗/使用人信息弹窗
        enterpriseOpen(code){
            // 0 企业资质   1 使用人信息 
            this.enterpriseCode = code
            this.enterpriseShow = true
        },
        enterpriseClose(){
            this.enterpriseShow = false
        },
        // 特殊业务标识弹窗
        specialBusinessOpen(code){
            this.specialBusinessShow = true
            this.specialBusinessType = code
            if(code == 0){
                this.specialBusinessValue = this.decHead.specDeclFlagText
            }else{

            }
        },
        specialBusinessClose(code,value,text){
            if(code === 0){
                this.decHead.specDeclFlag = value
                this.decHead.specDeclFlagText = text
            }else{

            }
            this.specialBusinessShow = false
        },
        // 价格确认弹窗
        priceClose(){
            this.priceShow = false
        },
        // 商品货物属性弹窗
        cargoOpen(){
            this.cargoShow = true
            if(this.decListItem.goodsAttr !== ''){
                this.$refs['cargoAttr'].cargoChange(this.decListItem.goodsAttr)
            }
        },
        cargoClose(code,codeName,codeValue){
            if(code){
                this.decListItem.goodsAttr = codeValue
                this.decListItem.goodsAttrText = codeName
            }
            this.cargoShow = false
        },
        // 协定享惠
        decDocLayerXiangHui(){
            this.xiangHuiContentShow = true
        },
        xiangHuiContentClose(code){
            this.xiangHuiContentShow = code
        },
        // 新增单证
        addLicenseList(){
            this.decLicenseDocusItem = JSON.parse(JSON.stringify(AEODec.decContainer))
            this.decLicenseDocusItem.licenseNum = this.decLicenseDocus.length+1
            // 清空表格选中数据
            this.decLicenseDocusSelect = {}
            this.$refs.decLicenseDocus.setCurrentRow();
        },
        // 删除选中单证
        delLicenseList(){
            if(this.decLicenseDocusSelect){
                this.$confirm('是否确认删除单证数据？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const index = this.decLicenseDocusSelect.licenseNum-1
                    this.decLicenseDocus.splice(index, 1)
                    // 重新排序
                    this.tableGNoSort('decLicenseDocus')
                    // 新增
                    this.addLicenseList()
                }).catch(() => {
                    return false          
                });
            }else{
                this.$message({
                    message: '请选中数据',
                    type: 'warning'
                });
            }
        },
        // 点击选中显示单证详情
        decLicenseDocusShow(val){
            if(val){
                this.decLicenseDocusItem = JSON.parse(JSON.stringify(val))
                // 选中数据赋值
                this.decLicenseDocusSelect = JSON.parse(JSON.stringify(val))
            }
        },
        // 回车添加单证
        enterLicenseList(){
            this.$refs.decLicenseDocusItem.validate((valid) => {
                if (valid) {
                    var item = JSON.parse(JSON.stringify(this.decLicenseDocusItem))
                    // 如果编号为空则赋值NA
                    if(item.certCode === ''){
                        item.certCode = 'NA'
                    }
                    if(this.decLicenseDocus.length >= this.decLicenseDocusItem.licenseNum){
                        // 修改
                        const updataNum = item.licenseNum - 1
                        this.$set(this.decLicenseDocus, updataNum , item);
                    }else{
                        // 新增
                        this.decLicenseDocus.push(item)
                    }
                    this.addLicenseList()
                }else{
                }
            })
        },
        // 删除报关单
        delDeclare(){
            this.$confirm('是否确认删除此报关单吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {   
                this.$api.deleteDecInfo( this.decHead.id ).then(res =>{
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });
                    // 跳转页面并关闭当前页面
                    // 历史选中菜单
                    var oldActivePath = this.$store.state.activePath
                    // 历史已选中菜单列表
                    var oldTabList = this.$store.state.tabList
                    const index = oldTabList.findIndex(item => item.name === oldActivePath);
                    if (index !== -1) {
                        oldTabList.splice(index, 1);
                    }
                    // 同时存储菜单
                    this.$store.commit('closeTab', { activePath: oldActivePath, tabList: oldTabList })
                    // 删除keepAlive缓存
                    this.$store.commit('removeKeepAliveCache', oldActivePath)
                    var submenuPath = ''
                    var submenuName = ''
                    var submenuLabel = ''
                    if(this.exportCode === 'E'){
                        submenuLabel = '出口报关整合单'
                        submenuPath = '/exportDeclare'
                        submenuName = 'exportDeclare'
                    }else if(this.exportCode === 'EML'){
                        submenuLabel = '出口备案清单'
                        submenuPath = '/exportDeclareML'
                        submenuName = 'exportDeclareML'
                    }else if(this.exportCode === 'I'){
                        submenuLabel = '进口报关整合单'
                        submenuPath = '/importDeclare'
                        submenuName = 'importDeclare'
                    }else{
                        submenuLabel = '进口备案清单'
                        submenuPath = '/importDeclareML'
                        submenuName = 'importDeclareML'
                    }
                    this.$store.commit('addKeepAliveCache', submenuName)
                    var submenu = {
                        path: submenuPath,
                        name: submenuName,
                        label: submenuLabel,
                    }
                    //修改选中菜单
                    this.$store.commit('selectMenu', submenu)
                    this.$router.push({ path:submenuPath })
                })
            }).catch(() => {});

        },
        // 货物暂存
        saveDecInfo(iftemporarily){ // 先判断是不是暂存
            if(iftemporarily){ // 是暂存
                // const checkText = this.checkDcl()
                // if(!checkText.checkCode){
                //     return false
                // }
                const params = {}
                params.decHead = this.decHead
                params.decList = this.decList
                params.decContainer = this.decContainer
                params.decLicense = this.decLicenseDocus
                this.$api.saveDecInfo( params ).then(res =>{
                    this.getdeclareDetails(res,false)
                    this.$message({
                        message: '暂存成功',
                        type: 'success'
                    });
                })
            }else{
                // 复审
                this.$refs.decHead.validate(async (valid) => {
                    if (valid) {
                        const checkText = await this.checkDcl()
                        if(!checkText.checkCode){
                            this.insWrongRecord(checkText.wrongInfo)
                            return false
                        }
                        this.$confirm('是否确认提交复审', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {   
                            const params = {}
                            params.decHead = this.decHead
                            params.decList = this.decList
                            params.decContainer = this.decContainer
                            params.decLicense = this.decLicenseDocus
                            this.$api.saveDecInfo( params ).then(res =>{
                                this.getdeclareDetails(res,false)
                                this.$message({
                                    message: '提交复审成功',
                                    type: 'success'
                                });
                            })
                        }).catch(() => {});
                    }else {
                        this.$message({
                            message: '请填写完整数据',
                            type: 'warning'
                        });
                        this.insWrongRecord('数据未填写完整')
                        return false;
                    }
                })
            }
        },
        // 添加错误记录
        insWrongRecord(wrongInfo){
            this.$api.insWrongRecord( wrongInfo,this.decHead.contrNo,this.decHead.billNo,this.decHead.id ).then(res =>{})
        },
        // 货物申报
        declareDecXml(){
            // 判断预录人和当前人是否是一个人，是则不允许申报
            if(this.decHead.inputerName === this.localStorageName ){
                this.$message({
                    message: '预录人与审核人不能是一个人！',
                    type: 'warning'
                });
                return false;
            }
            this.$refs.decHead.validate(async (valid) => {
                if (valid) {
                    const costCode = await this.checkDcl()
                    if(costCode){
                        // return false
                        this.$confirm('是否确认申报', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {   
                            const params = {}
                            params.decHead = this.decHead
                            params.decList = this.decList
                            params.decContainer = this.decContainer
                            params.decLicense = this.decLicenseDocus
                            this.$api.declareDecXml( params ).then(res =>{
                                this.getdeclareDetails(this.decHead.id,false)
                                this.$message({
                                    message: '申报成功',
                                    type: 'success'
                                });
                            })
                        }).catch(() => {});
                    }
                } else {
                    return false;
                }
            });
        },
        // 预审和申报的逻辑校验
        checkDcl(){
            if(this.decHead.packNo === '0'){
                this.$message({
                    message: '件数不能为0',
                    type: 'warning'
                });
                return {checkCode:false,wrongInfo:'件数为0'}
            }
            // 验证标体重量和表头重量是否一致
            if(this.decList.length){
                var weightTotal = 0
                for(var item of this.decList){
                    if(item.firstUnit === '035'){
                        weightTotal = currency(weightTotal,{precision: 4}).add(Number(item.firstQty)).value
                    }else if(item.secondUnit === '035'){
                        weightTotal = currency(weightTotal,{precision: 4}).add(Number(item.secondQty)).value
                    }
                }
                if(weightTotal !== Number(this.decHead.netWt)){
                    this.$message({
                        message: '表体重量与表头净重不相等',
                        type: 'warning'
                    });
                    return {checkCode:false,wrongInfo:'表体重量与表头净重不相等'}
                }
            }
            if( this.exportCode === 'E' || this.exportCode === 'EML' ){
                if(this.decHead.transMode === '1'){
                    if(this.decHead.feeMark === '' || this.decHead.insurMark === '' ){
                        this.$message({
                            message: '请输入运费和保费',
                            type: 'warning'
                        });
                        return {checkCode:false,wrongInfo:'未输入运费和保费'}
                    }
                }else if(this.decHead.transMode === '2') {
                    if(this.decHead.feeMark === '' ){
                        this.$message({
                            message: '请输入运费',
                            type: 'warning'
                        });
                        return {checkCode:false,wrongInfo:'未输入运费'}
                    }
                }else if(this.decHead.transMode === '4') {
                    if(this.decHead.insurMark === '' ){
                        this.$message({
                            message: '请输入保费',
                            type: 'warning'
                        });
                        return {checkCode:false,wrongInfo:'未输入保费'}
                    }
                }else if(this.decHead.transMode === '7'){
                    if(this.decHead.otherMark === '' ){
                        this.$message({
                            message: '请输入杂费',
                            type: 'warning'
                        });
                        return {checkCode:false,wrongInfo:'未输入杂费'}
                    }
                }
            }else{
                if(this.decHead.transMode === '2'){
                    if(this.decHead.insurMark === '' ){
                        this.$message({
                            message: '请输入保费',
                            type: 'warning'
                        });
                        return {checkCode:false,wrongInfo:'未输入保费'}
                    }
                }else if(this.decHead.transMode === '3') {
                    if(this.decHead.feeMark === '' || this.decHead.insurMark === '' ){
                        this.$message({
                            message: '请输入运费和保费',
                            type: 'warning'
                        });
                        return {checkCode:false,wrongInfo:'未输入运费和保费'}
                    }
                }else if(this.decHead.transMode === '4') {
                    if(this.decHead.feeMark === '' ){
                        this.$message({
                            message: '请输入运费',
                            type: 'warning'
                        });
                        return {checkCode:false,wrongInfo:'未输入运费'}
                    }
                }else if(this.decHead.transMode === '7'){
                    if(this.decHead.otherMark === '' || this.decHead.feeMark === '' || this.decHead.insurMark === '' ){
                        this.$message({
                            message: '请输入运费、保费和杂费',
                            type: 'warning'
                        });
                        return {checkCode:false,wrongInfo:'未输入运费、保费和杂费'}
                    }
                }
            }
            return {checkCode:true,wrongInfo:''}
        },
        // 新建或复制新建一单
        copyDeclare(iscopy){
            var submenuLabel = ''
            var submenuPath = ''
            var submenuName = ''
            if(this.exportCode === 'E'){ // 出口
                submenuLabel='出口报关整合单'
                submenuPath='/exportDeclare'
                submenuName='exportDeclare'
            }else if(this.exportCode === 'EML'){ // 出口备案
                submenuLabel='出口备案清单'
                submenuPath='/exportDeclareML'
                submenuName='exportDeclareML'
            }else if(this.exportCode ==='I'){ // 进口
                submenuLabel='进口报关整合单'
                submenuPath='/importDeclare'
                submenuName='importDeclare'
            }else if(this.exportCode === 'IML'){ // 进口备案
                submenuLabel='进口备案清单'
                submenuPath='/importDeclareML'
                submenuName='importDeclareML'
            }
            this.$store.commit('addKeepAliveCache', submenuName)
            var submenu = {
                path: submenuPath,
                name: submenuName,
                label: submenuLabel,
            }
            //修改选中菜单
            this.$store.commit('selectMenu', submenu)
            this.$router.push({ path: submenuPath })
            if(iscopy){
                this.$eventBus.$emit('data-exportID', { id: this.decHead.id })
            }
        },
        // 选择运抵国后默认指运港
        tradeCountryChange(value){
            this.countryList = []
            this.decHead.distinatePort = value + '000'
            // 表体的最终目的国相同
            this.decListItem.originCountry = value
            // 指运港列表
            this.harborList = AEObasicData.CUS_MAPPING_PORT_CODE_V.filter(item =>
                item.codeValue.toLowerCase().includes(this.decHead.distinatePort.toLowerCase())
            );
        },
        // 打开监管列表
        regulatoryOpen(){
            this.$refs['regulatoryCategory'].getList(this.decListItem.codeTs,this.decListItem.ciqCode)
        },
        // 关闭监管类型
        regulatoryClose(value){
            if(value !== ''){
                this.decListItem.ciqCode = value.id
                this.decListItem.ciqName = value.name
            }
        },
        // 双击监管类型框清除监管类型
        delregulatory(){
            if(this.decListItem.ciqCode !== ''){
                this.$confirm('是否清除监管类别名称?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.decListItem.ciqCode = ''
                    this.decListItem.ciqName = ''
                }).catch(() => {});
            }
        },
        // 关闭上传单证弹窗
        uploadClose(){
            this.uploadShow = false
        },
        // 打印
        report(){
            const manJson = require('../../grf/declare.json')
            var master = JSON.parse(JSON.stringify(this.decHead))
            master.iePortText = this.$refs['iePortText'].query.split("-")[1] // 进境关别
            master.trafModeText = this.$refs['trafModeText'].query.split("-")[1] // 运输方式
            master.tradeModeText = this.$refs['tradeModeText'].query.split("-")[1] // 监管方式
            master.cutModeText = this.$refs['cutModeText'].query.split("-")[1] // 征免性质
            master.tradeAreaCodeText = this.$refs['tradeAreaCodeText'].query.split("-")[1] // 贸易国(地区)
            master.tradeCountryText = this.$refs['tradeCountryText'].query.split("-")[1] // 启运国(地区)
            master.distinatePortText = this.$refs['distinatePortText'].query.split("-")[1] // 经停港
            master.entyPortCodeText = this.$refs['entyPortCodeText'].query.split("-")[1] // 入境口岸
            master.wrapTypeText = this.$refs['wrapTypeText'].query.split("-")[1] // 包装种类
            master.transModeText = this.$refs['transModeText'].query.split("-")[1] // 成交方式
            master.customMasterText = '(' + this.$refs['customMasterText'].query.split("-")[1] + ')' // 申报地海关
            master.feeRateText = master.feeMark === '' ? '' : master.feeMark === '1' ? (master.feeRate + '/率') : (master.feeCurr + '/' +master.feeRate + '/' + master.feeMark )
            master.insurRateText = master.insurMark === '' ? '' : master.insurMark === '1'?(master.insurRate + '/率') : (master.insurCurr + '/' +master.insurRate + '/' + master.insurMark )
            master.otherRateText = master.otherMark === '' ? '' : master.otherMark === '1'?(master.otherRate + '/率') : (master.otherCurr + '/' +master.otherRate + '/' + master.otherMark )
            if(this.exportCode === 'E' || this.exportCode === 'EML'){
                // 出口
                master.codeName = '出口'
                master.tradeCoSccName = '境内发货人'
                master.overseasConsigneeName = '境外收货人'
                master.iePortName = '出境关别'
                master.ieDateName = '出口日期'
                master.tradeCountryName = '运抵国(地区)'
                master.distinatePortName = '指运港'
                master.entyPortCodeName = '离境口岸'
                master.ownerCodeSccName = '生产销售单位'
                master.districtCodeName = '境内货源地' 
                master.goodsPlaceName = ''
                master.despPortCodeName = ''
            }else{
                // 进口
                master.despPortCodeText =  this.$refs['despPortCodeText'].query.split("-")[1] // 启运港
                master.despPortCodeValue = '(' + master.despPortCode + ')' // 启运港
                master.codeName = '进口'
                master.tradeCoSccName = '境内收货人'
                master.overseasConsigneeName = '境外发货人'
                master.iePortName = '进境关别'
                master.ieDateName = '进口日期'
                master.tradeCountryName = '启运国(地区)'
                master.distinatePortName = '经停港'
                master.entyPortCodeName = '入境口岸'
                master.ownerCodeSccName = '消费使用单位'
                master.districtCodeName = '境内目的地'
                master.goodsPlaceName = '货物存放地点'
                master.despPortCodeName = '启运港'

            }
            // 表体
            var table = JSON.parse(JSON.stringify(this.decList))
            table.forEach(item => {
                item.gUnitText = AEObasicData.CUS_UNIT.filter(aeoitem => 
                    aeoitem.codeValue.toLowerCase().includes(item.gUnit.toLowerCase())
                )[0].codeName // 计量单位名称
                item.firstUnitText = AEObasicData.CUS_UNIT.filter(aeoitem => 
                    aeoitem.codeValue.toLowerCase().includes(item.firstUnit.toLowerCase())
                )[0].codeName // 计量单位名称
                item.secondUnitText = item.secondUnit !== '' ? AEObasicData.CUS_UNIT.filter(aeoitem => 
                    aeoitem.codeValue.toLowerCase().includes(item.secondUnit.toLowerCase())
                )[0].codeName :'' // 计量单位名称
                if(this.exportCode === 'E' || this.exportCode === 'EML'){
                    // 出口
                    item.destinationCountryText = AEObasicData.CUS_MAPPING_COUNTRY_CODE_V.filter(aeoitem =>
                        aeoitem.codeValue.toLowerCase().includes(item.destinationCountry.toLowerCase())
                    )[0].codeName // 原产国
                    item.originCountryText = AEObasicData.CUS_MAPPING_COUNTRY_CODE_V.filter(aeoitem =>
                        aeoitem.codeValue.toLowerCase().includes(item.originCountry.toLowerCase())
                    )[0].codeName // 最终目的国
                }else{
                    // 进口
                    item.originCountryText = AEObasicData.CUS_MAPPING_COUNTRY_CODE_V.filter(aeoitem =>
                        aeoitem.codeValue.toLowerCase().includes(item.originCountry.toLowerCase())
                    )[0].codeName // 原产国
                    item.destinationCountryText = AEObasicData.CUS_MAPPING_COUNTRY_CODE_V.filter(aeoitem =>
                        aeoitem.codeValue.toLowerCase().includes(item.destinationCountry.toLowerCase())
                    )[0].codeName // 最终目的国
                }
                item.districtCodeText = AEObasicData.CUS_DISTRICT.filter(aeoitem =>
                    aeoitem.codeValue.toLowerCase().includes(item.districtCode.toLowerCase())
                )[0].codeName // 境内目的地/境内货源地
                item.destCodeText = item.destCode !== '' ? AEObasicData.CIQ_CITY_CN.filter(aeoitem =>
                    aeoitem.codeValue.toLowerCase().includes(item.destCode.toLowerCase())
                )[0].codeName:''
                item.dutyModeText = this.dutyModeList.filter(aeoitem =>
                    aeoitem.codeValue.toLowerCase().includes(item.dutyMode)
                )[0].codeName // 征免方式
                item.tradeCurrText = item.tradeCurr==='502' ? 'USD' : this.currencyList.filter(aeoitem =>
                    aeoitem.codeValue.toLowerCase().includes(item.tradeCurr.toLowerCase())
                )[0].codeName // 币制
            })
            const params = { master:master,table:table }
            var args = {
                report: manJson,
                data: params,
                type: "preview",
                FontEmbedding: true,  //指定嵌入字体数据
            };
            webapp_ws_ajax_run(args);
        },
        // 驳回
        reject(){
            this.$prompt('请输入驳回原因', '驳回', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(({ value }) => {
                this.$api.reject( this.decHead.id ,value ).then(res =>{
                    this.getdeclareDetails(this.decHead.id,false)
                    this.$message({
                        message: '驳回成功',
                        type: 'success'
                    });
                })
            }).catch(() => { 
            });
        },
        // 货物导入成功后获取数据
        importDetailData(res, file){
            this.decListItem = JSON.parse(JSON.stringify(AEODec.decListItem))
            // 覆盖商品列表
            this.decList = res.data
            this.decList.forEach(item => {
                    const gUnitList =  AEObasicData.CUS_UNIT.filter(aeoitem => 
                        aeoitem.codeName.toLowerCase().includes(item.gUnit.toLowerCase())
                    )
                    item.gUnit = gUnitList.length ? gUnitList[0].codeValue : undefined
                    if( !item.gUnit ){
                       this.$message.error('成交单位错误');
                    }
                    item.firstUnit = AEObasicData.CUS_UNIT.filter(aeoitem => 
                        aeoitem.codeName.toLowerCase().includes(item.firstUnit.toLowerCase())
                    )[0].codeValue
                    if(item.secondUnit !== ''){
                        item.secondUnit = AEObasicData.CUS_UNIT.filter(aeoitem => 
                            aeoitem.codeName.toLowerCase().includes(item.secondUnit.toLowerCase())
                        )[0].codeValue
                    }
                    item.destinationCountry = AEObasicData.CUS_MAPPING_COUNTRY_CODE_V.filter(aeoitem =>
                        aeoitem.cusCode.toLowerCase().includes(item.destinationCountry.toLowerCase())
                    )[0].codeValue // 最终目的国
                    item.originCountry = AEObasicData.CUS_MAPPING_COUNTRY_CODE_V.filter(aeoitem =>
                        aeoitem.cusCode.toLowerCase().includes(item.originCountry.toLowerCase())
                    )[0].codeValue // 原产国
            });
        },
        errorData(error, file, fileList){
            const errorObj = JSON.parse(error.message)
            const message = errorObj.message
            const errorMessage = message.replace(/\n/g, '<br>');
            this.$alert(errorMessage, '错误提示', {
                confirmButtonText: '确定',
                 type: 'error',
                 dangerouslyUseHTMLString: true,
                callback: action => {
                    
                }
            });
        },
        // 下载商品模板
        DowloadExcel(){
            // 构造文件路径
            const fileUrl =  `${process.env.BASE_URL}导入模板v1.0.xlsx`
            // 创建一个隐藏的a标签
            const link = document.createElement('a');
            link.href = fileUrl;
            link.download = '商品明细导入模板.xlsx'; // 设置下载后的文件名
            link.style.display = 'none';
            // 将a标签添加到DOM中
            document.body.appendChild(link);
            // 触发点击事件以开始下载
            link.click();
            // 下载完成后移除a标签
            setTimeout(() => document.body.removeChild(link), 100)
        },
    }
}
</script>
<style lang="css" scoped>
.nameInput{
    margin: 0px 10px;
    font-size: 14px;
}
::v-deep .el-table__body tr.current-row>td.el-table__cell{
    background-color: #ffc7ff !important;
}
 ::v-deep .yellow .el-input__inner {
    background-color: #FAFFBD;
}
.margin_right_20{
    margin-right: 20px;
}
.width_100{
    width: 100%;
}
.width_150{
    width: 150px;
}
.flex_start{
    display: flex;
}
.form_flex{
    margin: 0px 10px 30px 10px;
    display: flex;
    align-items: start;
    justify-content: space-between;
}
.top_flex{
    margin: 0px 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.form_declare{
    width: auto;
    margin-top: 10px;
}
.container{
    margin-top: 10px;
    width: 20%;
    height: 100%;
    min-width: 250px;
}
.el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
    margin-bottom: -1px;
     /* margin-bottom: 1px; */
}
.el-col {
    padding: 0px !important;
}
.input_width{
    width: calc(100% - 160px);
    margin-right: 10px;
}
.enterprise_buttons{
    display: flex;
    justify-content: flex-end;
    align-items: center;
}
.enterprise_buttons .el-button--mini.is-circle {
    margin-left: 0px !important;
}
.good_flex{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.good_flex .el-button--mini {
    padding: 3px 4px;
    font-size: 12px;
}
.good_flex .el-button .el-button, .el-checkbox.is-bordered .el-checkbox.is-bordered {
    margin-left: 5px;
}
.top_flex .el-button--mini {
    padding: 3px 4px;
    font-size: 12px;
}
.container .el-button--mini {
    padding: 3px 4px;
    font-size: 12px;
}
.el_input_group{
    display: flex;
}
.omitText{
    display: -webkit-box;
    -webkit-line-clamp: 2;    /* 限制显示行数 */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}
.tips_box{
    margin-top: 5px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    border-radius: 4px;
    background-color: white;
    padding: 5px;
    font-size: 14px;
}
.tips_item_width{
    width: 60px;
}
.tips_item{
    margin-left: 60px;
    margin-top: 2px;
}
.disabledInput{
    font-size: 12px;
    flex:1;
    background-color: #F5F7FA;
    border-color: #E4E7ED;
    color: #C0C4CC;
    cursor: not-allowed;
    height: 28px;
    line-height: 28px;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    box-sizing: border-box;
    display: inline-block;
    outline: 0;
    padding: 0 15px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    overflow: hidden;
     text-overflow: ellipsis;
}
::v-deep .el-row{
    margin-left: 0px !important;
    margin-right: 0px !important;
}
::v-deep .el-form-item__error{
    opacity: 0;
}
</style>